// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { DefaultConfig } from '../../settings/config'
import ToastMessage from '../../components/toast-messages'
import toast from 'react-hot-toast'
import { ApiUrls } from '../../utility/ApiUrls'

let getUserCall = false
const paginateArray = (array, perPage, page) => array.slice((page - 1) * perPage, page * perPage)
const sorting = DefaultConfig().sorter
const DateTimeConversion = DefaultConfig().DateTimeConversion
const DateConversion = DefaultConfig().DateConversion

let count = 0
const getUserApiCall = () => {
  axios.get(`${GlobalVariable.hostpath}api/Common/GetUIConfiguration`)
    .then((res) => {
      const result = res.data
      // callUiConfiguration = false
      if (result) {
        const data = result.data
        if (data) {
          const azureAdB2C = data.azureAdB2C
          const merchantOne = data.merchantOne
          const JsScriptData = data.jsScriptData
          azureAdB2C['apiUrl'] = GlobalVariable.hostpath
          azureAdB2C['hostname'] = window.location.origin
          localStorage.setItem('azureAdB2C', JSON.stringify(azureAdB2C))
          localStorage.setItem('merchantOne', JSON.stringify(merchantOne))
          localStorage.setItem('JsScriptData', JSON.stringify(JsScriptData))
          const expiryTimestamp = new Date().getTime() + (data.expiryTime * 60 * 1000)
          localStorage.setItem('expiryTime', expiryTimestamp)
          const localStorageToken = localStorage.getItem('token')
          axios.get(`${GlobalVariable.hostpath}api/User/GetUser`, {
            headers: { Authorization: `Bearer ${localStorageToken}` }
          }).then((res) => {
            const userData = res.data
            if (userData.success) {
              if (userData.data) {
                if (userData.data.isResetPassword === true) {
                  toast(t => (<ToastMessage t={t} message={"Your password has been changed successfully. Please Login..."} status={"success"} />))
                  setTimeout(() => {
                    localStorage.clear()
                    window.location.reload()
                  }, 3000)
                } else {
                  const cookies = new Cookies()
                  cookies.set('CustomClaims', res.headers["x-set-cookie"], { path: '/' })
                  localStorage.setItem('userData', JSON.stringify(userData.data))
                }
              }
            } else {
              toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
              localStorage.clear()
              window.location.reload()
            }
          }).catch((error) => {
            const errorresponse = error.response
            const azureAdB2C = localStorage.getItem('azureAdB2C')
            if (errorresponse) {
              const status = errorresponse.status
              if (status === 403 || status === 401) {
                localStorage.clear()
                window.location.reload()
              } else if (status === 406) {
                window.location.reload()
              } else if (status === 412) {
                const AzureB2CLogoutUrl = `${azureAdB2C.instance}/${azureAdB2C.domain}/${azureAdB2C.signUpSignInPolicyId}/oauth2/v2.0/logout?post_logout_redirect_uri=${azureAdB2C.hostname}&client_id=${localStorage.getItem('token')}`
                localStorage.clear()
                window.location.href = AzureB2CLogoutUrl
              } else if (status === 417 || status === 424) {
                if (count !== 2) {
                  count = count + 1
                }
                if ((count + 1) === 3) {
                  const AzureB2CLogoutUrl = `${azureAdB2C.instance}/${azureAdB2C.domain}/${azureAdB2C.signUpSignInPolicyId}/oauth2/v2.0/logout?post_logout_redirect_uri=${azureAdB2C.hostname}&client_id=${localStorage.getItem('token')}`
                  localStorage.clear()
                  window.location.href = AzureB2CLogoutUrl
                }
              } else {
                toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
                setTimeout(() => {
                  localStorage.clear()
                  window.location.reload()
                }, 2000)
              }
            }
          })
        }
      }
    }).catch((error) => {
      const errorresponse = error.response
      if (errorresponse) {
        const status = errorresponse.status
        if (status === 404) {
          toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
        }
      }
    })
}

const apiCall = async (method, endpoint, data, multi) => {
  const authAxios = DefaultConfig().authAxios
  if (method === 'get') {
    return await authAxios.get(endpoint)
      .then((response) => {
        const respData = response.data
        if (respData) {
          if (respData.success) {
            const resData = respData.data
            return resData
          } else {
            if (respData.errorMessage) {
              if (respData.errorMessage !== "Invoice Document Details Not Found") {
                toast(t => (<ToastMessage t={t} message={respData.errorMessage} status={"danger"} />))
              }
            } else {
              toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            }

            return ''
          }
        }
      }).catch((error) => {
        const errorresponse = error.response
        if (errorresponse) {
          const status = errorresponse.status
          if (status === 403) {
            return ''
          } else if (status === 406) {
            toast(t => (<ToastMessage t={t} message={"unauthorized"} status={"danger"} />))
            return ''
          } else if (status === 419) {
            if (!getUserCall) {
              getUserCall = true
              toast(t => (<ToastMessage t={t} message={"cookie"} status={"danger"} />))
              return ''
            }
          } else if (status === 401) {
            localStorage.clear()
            window.location.reload()
          } else {
            // const error = errorresponse.data.error
            toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            return ''
          }
        }
      })
  } else if (method === 'post') {
    return await authAxios.post(endpoint, data)
      .then((response) => {
        const respData = response.data

        if (respData) {
          if (respData.success) {
            const resData = respData.data
            return resData
          } else {
            if (respData.errorMessage) {
              toast(t => (<ToastMessage t={t} message={respData.errorMessage} status={"danger"} />))
            } else {
              if (!multi) {
                toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
              }
            }
            return ''
          }
        }
      }).catch((error) => {
        const errorresponse = error.response
        if (errorresponse) {
          const status = errorresponse.status
          if (status === 403) {
            return ''
          } else if (status === 406) {
            toast(t => (<ToastMessage t={t} message={"unauthorized"} status={"danger"} />))
            return ''
          } else if (status === 419) {
            if (!getUserCall) {
              getUserCall = true
              toast(t => (<ToastMessage t={t} message={"cookie"} status={"danger"} />))
              return ''
            }
          } else if (status === 401) {
            localStorage.clear()
            window.location.reload()
          } else {
            // const error = errorresponse.data.error
            toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            return ''
          }
        }
      })
  } else if (method === 'patch') {
    return await authAxios.patch(endpoint, data)
      .then((response) => {
        const respData = response.data
        if (respData) {
          if (respData.success) {
            const resData = respData.data
            return resData
          } else {
            if (respData.errorMessage) {
              toast(t => (<ToastMessage t={t} message={respData.errorMessage} status={"danger"} />))
            } else {
              toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            }
            return ''
          }
        }
      }).catch((error) => {
        const errorresponse = error.response
        if (errorresponse) {
          const status = errorresponse.status
          if (status === 403) {
            return ''
          } else if (status === 406) {
            toast(t => (<ToastMessage t={t} message={"unauthorized"} status={"danger"} />))
            return ''
          } else if (status === 401) {
            localStorage.clear()
            window.location.reload()
          } else {
            // const error = errorresponse.data.error
            toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            return ''
          }
        }
      })
  } else if (method === 'delete') {
    return await authAxios.delete(endpoint)
      .then((response) => {
        const respData = response.data
        if (respData) {
          if (respData.success) {
            const resData = respData.data
            return resData
          } else {
            if (respData.errorMessage) {
              toast(t => (<ToastMessage t={t} message={respData.errorMessage} status={"danger"} />))
            } else {
              toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            }
            return ''
          }
        }
      }).catch((error) => {
        const errorresponse = error.response
        if (errorresponse) {
          const status = errorresponse.status
          if (status === 403) {
            return ''
          } else if (status === 406) {
            toast(t => (<ToastMessage t={t} message={"unauthorized"} status={"danger"} />))
            return ''
          } else if (status === 419) {
            if (!getUserCall) {
              getUserCall = true
              toast(t => (<ToastMessage t={t} message={"cookie"} status={"danger"} />))
              return ''
            }
          } else if (status === 401) {
            localStorage.clear()
            window.location.reload()
          } else {
            // const error = errorresponse.data.error
            toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            return ''
          }
        }
      })
  }
}

export const getAllCurrencyLookupData = createAsyncThunk("appCommonReducers/getAllCurrencyLookupData", async () => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetCurrencyLookupData}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    const lookupdata = []
    resultData.forEach((element) => {
      lookupdata.push({ value: element.id, label: `${element.name} - ${element.symbol}`, symbol: element.symbol, name: element.name, code: element.code })
    })
    return {
      data: lookupdata,
      data1: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: null,
      spinner: true,
      tokenExp: false
    }
  }
})

export const UpdateProductCodeMapping = createAsyncThunk("appCommonReducers/UpdateProductCodeMapping", async (wdata) => {
  const method = 'patch'
  const endpoint = `${ApiUrls.UpdateProductCodeMapping}`
  const data = wdata
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: null,
      spinner: true,
      tokenExp: false
    }
  }
})

export const getCurrencyLookupData = createAsyncThunk("appCommonReducers/getCurrencyLookupData", async (wdata) => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetCurrencyLookupData}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      perPage: wdata.perPage,
      page: wdata.page,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: null,
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetAgentDetailsByDocumentId = createAsyncThunk("appCommonReducers/GetAgentDetailsByDocumentId", async (wdata) => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetAgentDetailsByDocumentId}?documentKey=${wdata}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: null,
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetInvoiceDocument = createAsyncThunk("appCommonReducers/GetInvoiceDocument", async (wdata) => {
  const method = 'post'
  const endpoint = `${ApiUrls.GetInvoiceDocument}`
  const data = wdata
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

export const CreateCurrencyLookupData = createAsyncThunk("appCommonReducers/CreateCurrencyLookupData", async (wdata) => {
  const method = 'post'
  const endpoint = `${ApiUrls.CreateCurrencyLookupData}`
  const data = wdata.data
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: wdata,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: null,
      spinner: true,
      tokenExp: false
    }
  }
})

export const UpdateCurrecyLookupData = createAsyncThunk("appCommonReducers/UpdateCurrecyLookupData", async (wdata) => {
  const method = 'post'
  const endpoint = `${ApiUrls.UpdateCurrecyLookupData}?id=${wdata.id}`
  const data = wdata.data
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: wdata,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: null,
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetDialyExchangeData = createAsyncThunk("appCommonReducers/GetDialyExchangeData", async (wdata) => {
  const method = 'post'
  const endpoint = `${ApiUrls.GetDialyExchangeData}`
  const data = wdata
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: null,
      spinner: true,
      tokenExp: false
    }
  }
})

export const CFilterApprovalData = createAsyncThunk("appCommonReducers/CFilterApprovalData", async (obj) => {
  const method = 'post'
  const endpoint = ApiUrls.FilterApprovalData
  const payload = obj.payload
  const wdata = obj.pageData
  const resultData = await apiCall(method, endpoint, payload)
  if (resultData) {
    return {
      data: resultData,
      perPage: wdata.perPage,
      page: wdata.page,
      searchSymbol: wdata.searchSymbol,
      fromCreatedDate: wdata.fromCreatedDate,
      toCreatedDate: wdata.toCreatedDate,
      rfromCreatedDate: wdata.rfromCreatedDate,
      rtoCreatedDate: wdata.rtoCreatedDate,
      requestedBy: wdata.requestedBy,
      approvedBy: wdata.approvedBy,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const UpdateCurrencyLookupStatus = createAsyncThunk("appCommonReducers/UpdateCurrencyLookupStatus", async (wdata) => {
  const method = 'post'
  const endpoint = `${ApiUrls.UpdateCurrencyLookupStatus}?id=${wdata.aId}`
  const data = wdata
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      success: true,
      tokenExp: false
    }
  } else {
    return {
      data: null,
      spinner: true,
      success: false,
      tokenExp: false
    }
  }
})

export const GetUserByEmail = createAsyncThunk("appCommonReducers/GetUserByEmail", async (wdata) => {
  const method = 'post'
  const endpoint = `${ApiUrls.GetUserByEmail}`
  const data = wdata
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      success: true,
      tokenExp: false
    }
  } else {
    return {
      data: null,
      spinner: true,
      success: false,
      tokenExp: false
    }
  }
})

export const CurrencyHistoryData = createAsyncThunk("appCommonReducers/CurrencyHistoryData", async (obj) => {
  const method = 'get'
  const endpoint = ApiUrls.GetAllCurrencyLookupHistory
  const payload = obj.payload
  const wdata = obj.pageData
  const resultData = await apiCall(method, endpoint, payload)
  if (resultData) {
    return {
      data: resultData,
      perPage: wdata.perPage,
      page: wdata.page,
      searchSymbol: wdata.searchSymbol,
      fromCreatedDate: wdata.fromCreatedDate,
      toCreatedDate: wdata.toCreatedDate,
      requestedBy: wdata.requestedBy,
      approvedBy: wdata.approvedBy,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetAllCompanyCurrencyList = createAsyncThunk("appCommonReducers/GetAllCompanyCurrencyList", async (obj) => {
  const method = 'post'
  const endpoint = ApiUrls.GetAllCompanyCurrencyList
  const payload = obj.payload
  const resultData = await apiCall(method, endpoint, payload)
  if (resultData) {
    const companyCurrencyList = resultData.companyCurrencyList
    return {
      data: companyCurrencyList,
      perPage: payload.pageSize,
      page: payload.pageNo,
      count: resultData.count,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const CMFilterApprovalData = createAsyncThunk("appCommonReducers/CMFilterApprovalData", async (obj) => {
  const method = 'post'
  const endpoint = ApiUrls.FilterApprovalData
  const payload = obj.payload
  const wdata = obj.pageData
  const resultData = await apiCall(method, endpoint, payload)
  if (resultData) {
    return {
      data: resultData,
      perPage: wdata.perPage,
      page: wdata.page,
      searchSymbol: wdata.searchSymbol,
      fromCreatedDate: wdata.fromCreatedDate,
      toCreatedDate: wdata.toCreatedDate,
      rfromCreatedDate: wdata.rfromCreatedDate,
      rtoCreatedDate: wdata.rtoCreatedDate,
      agentId: wdata.agentId,
      requestedBy: wdata.requestedBy,
      approvedBy: wdata.approvedBy,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const UpdateCurrencyCurrencyMappingStatus = createAsyncThunk("appCommonReducers/UpdateCurrencyCurrencyMappingStatus", async (wdata) => {
  const method = 'post'
  const endpoint = `${ApiUrls.UpdateCurrencyCurrencyMappingStatus}?id=${wdata.aId}`
  const data = wdata
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      success: true,
      tokenExp: false
    }
  } else {
    return {
      data: null,
      spinner: true,
      success: false,
      tokenExp: false
    }
  }
})

// Get Company Details in salesforce
export const GetCompanyDetailsByName = createAsyncThunk("appCommonReducers/GetCompanyDetailsByName", async (name) => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetAgentDetails}?agent=${name}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  return resultData
})

export const GetVesselsDetailsByName = createAsyncThunk("appCommonReducers/GetVesselsDetailsByName", async (name) => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetVesselDetails}?vessel=${name}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  return resultData
})

// Get Company Details in salesforce
export const GetCompanyMappingDataByAgent = createAsyncThunk("appCommonReducers/GetCompanyMappingDataByAgent", async (id) => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetCompanyMappingDataByAgent}?agentId=${id}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  return resultData
})

export const PreviewADMDocument = createAsyncThunk("appCommonReducers/PreviewADMDocument", async (wdata) => {
  const method = 'post'
  const endpoint = `${ApiUrls.PreviewADMDocument}`
  const data = wdata
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetADMRevisions = createAsyncThunk("appCommonReducers/GetADMRevisions", async (wdata) => {
  const method = 'post'
  const endpoint = `${ApiUrls.GetADMRevisions}`
  const data = wdata
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: null,
      spinner: true,
      tokenExp: false
    }
  }
})

export const GenerateADMDocument = createAsyncThunk("appCommonReducers/GenerateADMDocument", async (wdata) => {
  const method = 'post'
  const endpoint = `${ApiUrls.GenerateADMDocument}`
  const data = wdata
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: null,
      spinner: true,
      tokenExp: false
    }
  }
})

export const AddOrUpdateCompayMappingData = createAsyncThunk("appCommonReducers/AddOrUpdateCompayMappingData", async (wdata) => {
  const method = 'post'
  const endpoint = `${ApiUrls.AddOrUpdateCompayMappingData}`
  const data = wdata
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: wdata,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: null,
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetDownloadDocument = createAsyncThunk("appCommonReducers/GetDownloadDocument", async (fdata) => {
  const method = 'get'
  const endpoint = `${ApiUrls.DownloadFile}?fileId=${fdata.fileId}&agentId=${fdata.agentId}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetADMDownloadDocument = createAsyncThunk("appCommonReducers/GetADMDownloadDocument", async (Admfdata) => {
  const method = 'get'
  const endpoint = `${ApiUrls.ADMDownloadFile}?fileId=${Admfdata.fileId}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

export const CompanyHistoryData = createAsyncThunk("appCommonReducers/CompanyHistoryData", async (obj) => {
  const method = 'post'
  const endpoint = ApiUrls.GetAllCompanyCurrencyHistory
  const payload = obj.payload
  const resultData = await apiCall(method, endpoint, payload)
  if (resultData) {
    const companyCurrencyList = resultData.companyCurrencyList
    return {
      data: companyCurrencyList,
      perPage: payload.pageSize,
      page: payload.pageNo,
      count: resultData.count,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetAllProductPrices = createAsyncThunk("appCommonReducers/GetAllProductPrices", async (obj) => {
  const method = 'post'
  const endpoint = `${ApiUrls.GetAllProductPrices}`
  const payload = obj.payload
  const resultData = await apiCall(method, endpoint, payload)
  if (resultData) {
    const productPriceBookList = resultData.productPriceBookList
    return {
      data: productPriceBookList,
      perPage: payload.pageSize,
      page: payload.pageNo,
      count: resultData.count,
      isDownload: payload.isDownload,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const UpdateProductCodePriceData = createAsyncThunk("appCommonReducers/UpdateProductCodePriceData", async (wdata) => {
  const method = 'post'
  const endpoint = `${ApiUrls.UpdateProductCodePriceData}?id=${wdata.ProductId}`
  const data = wdata
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: wdata,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: null,
      spinner: true,
      tokenExp: false
    }
  }
})

export const PBFilterApprovalData = createAsyncThunk("appCommonReducers/PBFilterApprovalData", async (obj) => {
  const method = 'post'
  const endpoint = ApiUrls.FilterApprovalData
  const payload = obj.payload
  const wdata = obj.pageData
  const resultData = await apiCall(method, endpoint, payload)
  if (resultData) {
    return {
      data: resultData,
      perPage: wdata.perPage,
      page: wdata.page,
      searchSymbol: wdata.searchSymbol,
      fromCreatedDate: wdata.fromCreatedDate,
      toCreatedDate: wdata.toCreatedDate,
      agentId: wdata.agentId,
      productCode: wdata.productCode,
      requestedBy: wdata.requestedBy,
      approvedBy: wdata.approvedBy,
      rfromCreatedDate: wdata.rfromCreatedDate,
      rtoCreatedDate: wdata.rtoCreatedDate,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const UpdateProductPriceStatus = createAsyncThunk("appCommonReducers/UpdateProductPriceStatus", async (wdata) => {
  const method = 'post'
  const endpoint = `${ApiUrls.UpdateProductPriceStatus}?id=${wdata.aId}`
  const data = wdata
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      success: true,
      tokenExp: false
    }
  } else {
    return {
      data: null,
      spinner: true,
      success: false,
      tokenExp: false
    }
  }
})

export const GetAllProductHistoryData = createAsyncThunk("appCommonReducers/GetAllProductHistoryData", async (obj) => {
  const method = 'post'
  const endpoint = ApiUrls.GetAllProductHistoryData
  const payload = obj.payload
  const resultData = await apiCall(method, endpoint, payload)
  if (resultData) {
    const productHistory_DTO = resultData.productHistory_DTO
    return {
      data: productHistory_DTO,
      perPage: payload.pageSize,
      page: payload.pageNo,
      count: resultData.count,
      isDownload: payload.isDownload,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const PriceHistoryData = createAsyncThunk("appCommonReducers/PriceHistoryData", async (obj) => {
  const method = 'post'
  const endpoint = ApiUrls.FilterApprovalData
  const payload = obj.payload
  const wdata = obj.pageData
  const resultData = await apiCall(method, endpoint, payload)
  if (resultData) {
    return {
      data: resultData,
      perPage: wdata.perPage,
      page: wdata.page,
      searchSymbol: wdata.searchSymbol,
      fromCreatedDate: wdata.fromCreatedDate,
      toCreatedDate: wdata.toCreatedDate,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetAllProductCodes = createAsyncThunk("appCommonReducers/GetAllProductCodes", async (obj) => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetAllProductCodes}`
  const payload = ''
  const wdata = obj
  const resultData = await apiCall(method, endpoint, payload)
  if (resultData) {
    if (obj !== "getapi") {
      return {
        data: resultData,
        perPage: wdata.perPage,
        page: wdata.page,
        productCode: wdata.productCode,
        lockValue: wdata.lockValue,
        statusDiffvalue: obj.statusDiffvalue,
        priceDiffvalue: obj.priceDiffvalue,
        variablevalue: obj.variablevalue,
        sortname: obj.sortname,
        sortorder: obj.sortorder,
        spinner: true,
        tokenExp: false
      }
    } else {
      return {
        data: resultData,
        spinner: true,
        tokenExp: false
      }
    }

  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})


// Get Employee Dashboard WOrkorders based on pagination
export const GetUsers = createAsyncThunk("appCommonReducers/GetUsers", async () => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetUsers}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)

  if (resultData) {
    const allUsers = []
    resultData.forEach((element) => {
      allUsers.push({ userId: element.id, name: element.fullName, email: element.email, companyId: element.companyId, status: element.isActive ? 'Active' : 'InActive' })
    })
    return {
      data: allUsers,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetAllRoles = createAsyncThunk("appCommonReducers/GetAllRoles", async () => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetAllRoles}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const CreateUser = createAsyncThunk("appCommonReducers/CreateUser", async (wdata) => {
  const method = 'post'
  const endpoint = `${ApiUrls.CreateUser}`
  const data = wdata
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    // toast(t => (<ToastMessage t={t} message={resultData} status={"sucesss"} />))
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetUserRoles = createAsyncThunk("appCommonReducers/GetUserRoles", async (uid) => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetUserRoles}?userId=${uid}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)

  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const SaveUserRoles = createAsyncThunk("appCommonReducers/SaveUserRoles", async (rdata) => {
  const method = 'post'
  const endpoint = `${ApiUrls.SaveUserRoles}?userId=${rdata.userId}`
  const data = rdata.data
  const resultData = await apiCall(method, endpoint, data)

  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetDocumentStatus = createAsyncThunk("appCommonReducers/GetDocumentStatus", async (wdata) => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetDocumentStatus}?invoiceNumber=${wdata.invoiceNumber}`
  const resultData = await apiCall(method, endpoint)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetSalesTransactionWorkDetails = createAsyncThunk("appCommonReducers/GetSalesTransactionWorkDetails", async (wdata) => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetSalesTransactionWorkDetails}?invoiceNumber=${wdata.invoiceNumber}&agentNumber=${wdata.agentId}`
  const resultData = await apiCall(method, endpoint)

  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetSalesTransactionHistoryDetails = createAsyncThunk("appCommonReducers/GetSalesTransactionHistoryDetails", async (wdata) => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetSalesTransactionHistoryDetails}?invoiceNumber=${wdata.invoiceNumber}&agentNumber=${wdata.agentId}`
  const resultData = await apiCall(method, endpoint)

  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: null,
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetDocumentHistoryDistributionDetails = createAsyncThunk("appCommonReducers/GetDocumentHistoryDistributionDetails", async (wdata) => {
  const method = 'post'
  const endpoint = `${ApiUrls.GetDocumentHistoryDistributionDetails}`
  const resultData = await apiCall(method, endpoint, wdata)

  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetDocumentWorkDistributionDetails = createAsyncThunk("appCommonReducers/GetDocumentWorkDistributionDetails", async (wdata) => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetDocumentWorkDistributionDetails}?invoiceNumber=${wdata.invoiceNumber}`
  const resultData = await apiCall(method, endpoint)

  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetPaymentDetails = createAsyncThunk("appCommonReducers/GetPaymentDetails", async (wdata) => {

  const method = 'get'
  const endpoint = `${ApiUrls.GetPaymentDetails}?invoiceNumber=${wdata.invoiceNumber}&agentNumber=${wdata.agentId}`
  const resultData = await apiCall(method, endpoint)

  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetAllDiscountsData = createAsyncThunk("appCommonReducers/GetAllDiscountsData", async (disData) => {
  const method = 'post'
  const endpoint = `${ApiUrls.GetAllDiscountsData}`
  const data = disData
  const resultData = await apiCall(method, endpoint, data)

  if (resultData) {
    return {
      data: resultData?.discountsList,
      recCount: resultData?.count,
      pageSize: data?.pageSize,
      page: data?.pageIndex,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetAllVesselDiscounts = createAsyncThunk("appCommonReducers/GetAllVesselDiscounts", async (disData) => {
  const method = 'post'
  const endpoint = `${ApiUrls.GetAllVesselDiscounts}`
  const data = disData
  data['VesselName'] = disData?.vesselId
  delete data?.vesselId
  const resultData = await apiCall(method, endpoint, data)

  if (resultData) {
    return {
      data: resultData?.vesselDiscountsList,
      recCount: resultData?.count,
      pageSize: data?.pageSize,
      page: data?.pageIndex,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const CreateDiscount = createAsyncThunk("appCommonReducers/CreateDiscount", async (wdata) => {
  const method = 'post'
  const endpoint = `${ApiUrls.CreateDiscount}`
  const data = wdata
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: null,
      spinner: true,
      tokenExp: false
    }
  }
})

export const CreateVDiscount = createAsyncThunk("appCommonReducers/CreateVDiscount", async (wdata) => {
  const method = 'post'
  const endpoint = `${ApiUrls.CreateVDiscount}`
  const data = wdata
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: null,
      spinner: true,
      tokenExp: false
    }
  }
})

export const ValidateAgentDiscount = createAsyncThunk("appCommonReducers/ValidateAgentDiscount", async (wdata) => {
  const method = 'post'
  const endpoint = `${ApiUrls.ValidateAgentDiscount}`
  const data = wdata
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: null,
      spinner: true,
      tokenExp: false
    }
  }
})

export const ValidateVesselDiscount = createAsyncThunk("appCommonReducers/ValidateVesselDiscount", async (wdata) => {
  const method = 'post'
  const endpoint = `${ApiUrls.ValidateVesselDiscount}`
  const data = wdata
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: null,
      spinner: true,
      tokenExp: false
    }
  }
})

export const UpdateDiscountLookUpStatus = createAsyncThunk("appCommonReducers/UpdateDiscountLookUpStatus", async (wdata) => {
  const method = 'post'
  const endpoint = `${ApiUrls.UpdateDiscountLookUpStatus}`
  const data = wdata
  const resultData = await apiCall(method, endpoint, data, 'multi')
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      success: true,
      tokenExp: false
    }
  } else {
    return {
      data: null,
      spinner: true,
      success: false,
      tokenExp: false
    }
  }
})

export const UpdateVDiscountLookUpStatus = createAsyncThunk("appCommonReducers/UpdateVDiscountLookUpStatus", async (wdata) => {
  const method = 'post'
  const endpoint = `${ApiUrls.UpdateVDiscountLookUpStatus}`
  const data = wdata
  const resultData = await apiCall(method, endpoint, data, 'multi')
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      success: true,
      tokenExp: false
    }
  } else {
    return {
      data: null,
      spinner: true,
      success: false,
      tokenExp: false
    }
  }
})

export const DFilterApprovalData = createAsyncThunk("appCommonReducers/DFilterApprovalData", async (obj) => {
  const method = 'post'
  const endpoint = ApiUrls.FilterApprovalData
  const payload = obj.payload
  const wdata = obj.pageData
  const resultData = await apiCall(method, endpoint, payload)
  if (resultData) {
    return {
      data: resultData,
      perPage: wdata.perPage,
      page: wdata.page,
      agentId: wdata.agentId,
      productCode: wdata.productCode,
      requestedBy: wdata.requestedBy,
      approvedBy: wdata.approvedBy,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})


export const VDFilterApprovalData = createAsyncThunk("appCommonReducers/VDFilterApprovalData", async (obj) => {
  const method = 'post'
  const endpoint = ApiUrls.FilterApprovalData
  const payload = obj.payload
  const wdata = obj.pageData
  const resultData = await apiCall(method, endpoint, payload)
  if (resultData) {
    return {
      data: resultData,
      perPage: wdata.perPage,
      page: wdata.page,
      vesselId: wdata.vesselId,
      productCode: wdata.productCode,
      requestedBy: wdata.requestedBy,
      approvedBy: wdata.approvedBy,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const DHFilterApprovalData = createAsyncThunk("appCommonReducers/DHFilterApprovalData", async (obj) => {
  const method = 'post'
  const endpoint = ApiUrls.GetAllDiscountsData
  const wdata = obj
  delete wdata.type
  const resultData = await apiCall(method, endpoint, wdata)
  if (resultData) {
    return {
      data: resultData,
      pageSize: wdata.pageSize,
      page: wdata.pageIndex,
      recCount: resultData.count,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const DHFilterApprovalDatas = createAsyncThunk("appCommonReducers/DHFilterApprovalDatas", async (obj) => {
  const method = 'post'
  const endpoint = ApiUrls.GetAllDiscountApprovals
  const wdata = obj
  wdata['type'] = 4
  // delete wdata.type
  const resultData = await apiCall(method, endpoint, wdata)
  if (resultData) {
    return {
      data: resultData,
      pageSize: wdata.pageSize,
      page: wdata.pageIndex,
      recCount: resultData.count,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const VDHFilterApprovalDatas = createAsyncThunk("appCommonReducers/VDHFilterApprovalDatas", async (obj) => {
  const method = 'post'
  const endpoint = ApiUrls.GetAllVesselDiscountApprovals
  const data = obj
  data['type'] = 5
  data['VesselName'] = obj?.vesselId
  delete data?.vesselId
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      pageSize: data.pageSize,
      page: data.pageIndex,
      recCount: resultData.count,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetAllExpiredDiscounts = createAsyncThunk("appCommonReducers/GetAllExpiredDiscounts", async (obj) => {
  const method = 'post'
  const endpoint = ApiUrls.GetAllExpiredDiscounts
  const wdata = obj
  wdata.status = 1
  wdata.isActive = true
  delete wdata.type
  const resultData = await apiCall(method, endpoint, wdata)
  if (resultData) {
    return {
      data: resultData,
      pageSize: wdata.pageSize,
      page: wdata.pageIndex,
      recCount: resultData.count,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetAllExpiredVesselDiscounts = createAsyncThunk("appCommonReducers/GetAllExpiredVesselDiscounts", async (obj) => {
  const method = 'post'
  const endpoint = ApiUrls.GetAllExpiredVesselDiscounts
  const data = obj
  data.status = 1
  data.isActive = true
  data['VesselName'] = obj?.vesselId
  delete data?.vesselId
  delete data?.type
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData?.vesselDiscountsList,
      pageSize: data.pageSize,
      page: data.pageIndex,
      recCount: resultData.count,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})


export const UpdateDiscountLookupId = createAsyncThunk("appCommonReducers/UpdateDiscountLookupId", async (wdata) => {
  const method = 'post'
  const endpoint = `${ApiUrls.UpdateDiscountLookupId}`
  const data = wdata
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: wdata,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: null,
      spinner: true,
      tokenExp: false
    }
  }
})

export const UpdateVDiscountLookupId = createAsyncThunk("appCommonReducers/UpdateVDiscountLookupId", async (wdata) => {
  const method = 'post'
  const endpoint = `${ApiUrls.UpdateVDiscountLookupId}`
  const data = wdata
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: wdata,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: null,
      spinner: true,
      tokenExp: false
    }
  }
})

export const getRefreshToken = createAsyncThunk("appCommonReducers/getRefreshToken", async () => {
  const method = 'get'
  const endpoint = `User/GetRefreshToken`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    localStorage.setItem("token", resultData.id_token)
    localStorage.setItem("refresh_token", resultData.refresh_token)
    getUserApiCall()
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: null,
      spinner: true,
      tokenExp: false
    }
  }
})

export const getData = createAsyncThunk("appCommonReducers/getData", async (wdata) => {
  return wdata
})

export const getCHistoryData = createAsyncThunk("appCommonReducers/getCHistoryData", async (wdata) => {
  return wdata
})

export const getCompanyData = createAsyncThunk("appCommonReducers/getCompanyData", async (wdata) => {
  return wdata
})

export const getPriceBookPendingData = createAsyncThunk("appCommonReducers/getPriceBookPendingData", async (wdata) => {
  return wdata
})

export const getComHistoryData = createAsyncThunk("appCommonReducers/getComHistoryData", async (wdata) => {
  return wdata
})
export const getDisHistoryData = createAsyncThunk("appCommonReducers/getDisHistoryData", async (wdata) => {
  return wdata
})

export const getVDisHistoryData = createAsyncThunk("appCommonReducers/getVDisHistoryData", async (wdata) => {
  return wdata
})

export const getPriceHistoryData = createAsyncThunk("appCommonReducers/getPriceHistoryData", async (wdata) => {
  return wdata
})

export const getPriceData = createAsyncThunk("appCommonReducers/getPriceData", async (wdata) => {
  return wdata
})

export const getProductData = createAsyncThunk("appCommonReducers/getProductData", async (wdata) => {
  return wdata
})

export const getWoLoading = createAsyncThunk("appCommonReducers/getWoLoading", async () => {
  return ''
})

export const paymentDetailsInoviceSearchBool = createAsyncThunk("appCommonReducers/getWoLoading", async () => {
  return ''
})

export const getDiscountPendingFData = createAsyncThunk("appCommonReducers/getDiscountPendingFData", async (wdata) => {
  return wdata
})

export const commonreducerSlice = createSlice({
  name: 'appCommonReducers',
  initialState: {
    cdSpinner: false,
    allData: [],
    data: [],
    totalCount: 1,
    perPage: 0,
    page: 1,

    hSpinner: false,
    hallData: [],
    hdata: [],
    htotalCount: 1,
    hperPage: 0,
    hpage: 1,
    hcount: 0,
    excelData: [],

    pbSpinner: false,
    pballData: [],
    pbdata: [],
    pbtotalCount: 1,
    pbperPage: 0,
    pbpage: 1,
    pbhisData: [],

    recCount: 0,
    gridSize: 0,
    tokenExp: false,
    symbolData: [],
    hisData: [],

    allCData: [],
    cSpinner: false,

    usersData: null,
    uspiner: false,
    userRoleData: [],
    urspiner: false,
    historyDistributions: [],
    historyDetails: [],
    pSpinner: false,
    pallData: [],
    phallData: [],
    pdata: [],
    hallDisData: [],
    ptotalCount: 1,
    pperPage: 0,
    ppage: 1,

    dSpinner: false,
    devData: null,
    InvoicesearchpaymentBool: false,
    invoiceDocument: null,
    discounts: [],
    HistoryDiscountData: []
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getWoLoading.fulfilled, (state) => {
        // state.allData = []
        // state.data = []
        // state.totalCount = 1

        state.hallData = []
        state.hdata = []
        state.htotalCount = 1

        state.pballData = []
        state.pbdata = []
        state.pbtotalCount = 1
        state.pbhisData = []
        state.excelData = []

      })
      // .addCase(GetDocumentHistoryDistributionDetails.rejected, (state, action) => {
      //   //  state.historyDetails=
      // })
      // .addCase()
      .addCase(getAllCurrencyLookupData.fulfilled, (state, action) => {
        if (action.payload?.data) {
          state.allCData = action.payload.data
          state.cSpinner = action.payload.spinner

          const perPage = 25
          const page = 1
          const arrayOfObjectsWithDates = action.payload.data1

          const woDataObj = []
          for (let i = 0; i < arrayOfObjectsWithDates.length; i++) {
            const data = arrayOfObjectsWithDates[i]
            data['currencyName'] = `${data.code} - ${data.name} (${data.symbol})`
            data['markUpData'] = `${Number(data.markUp).toFixed(3)} %`
            data['fixedRate'] = `${Number(data.fxRate).toFixed(4)} ${data.symbol}/$`
            data['dialyRate'] = `${data.fxRate} ${data.symbol}/$`
            const topValue = Number(data.fxRate) - Number(data.fxRate)
            const bottomValue = Number(data.fxRate) - (Number(data.fxRate) / 2)
            const totalValue = (topValue / bottomValue) * 100
            data['deviation'] = `${totalValue === 'NaN' ? totalValue : 0} ${data.symbol}/$`
            const finalRate = Number(data.fxRate) + ((Number(data.markUp) / 100) * Number(data.fxRate))
            data['finalRate'] = `${(finalRate).toFixed(4)} ${data.symbol}/$`

            const eleObj = {}
            eleObj['value'] = data.code
            eleObj['label'] = `${data.name} - ${data.code}`
            woDataObj.push(eleObj)
          }
          state.symbolData = woDataObj
          state.allData = arrayOfObjectsWithDates
          state.data = paginateArray(arrayOfObjectsWithDates, perPage, page)
          state.totalCount = arrayOfObjectsWithDates.length
          state.perPage = perPage
          state.page = page
          state.cdSpinner = action.payload.spinner
        }
      })


      // start currency menu
      // current tab
      .addCase(getCurrencyLookupData.fulfilled, (state, action) => {
        if (action.payload?.data) {
          const perPage = action.payload.perPage
          const page = action.payload.page
          const arrayOfObjectsWithDates = action.payload.data
          state.allData = arrayOfObjectsWithDates
          state.data = paginateArray(arrayOfObjectsWithDates, perPage, page)
          state.totalCount = arrayOfObjectsWithDates.length
          state.perPage = perPage
          state.page = page
          state.cdSpinner = action.payload.spinner
          const woDataObj = []
          for (let i = 0; i < arrayOfObjectsWithDates.length; i++) {
            const data = arrayOfObjectsWithDates[i]
            const eleObj = {}
            eleObj['value'] = data.code
            eleObj['label'] = `${data.name} - ${data.code}`
            woDataObj.push(eleObj)
          }
          state.symbolData = woDataObj
        }
      })
      // .addCase(GetPaymentDetails.fulfilled, (state, action) => {
      //   if (action.payload?.data) {
      //     state.InvoicesearchpaymentBool = true
      //   }
      // })
      .addCase(getData.fulfilled, (state, action) => {
        const perPage = action.payload.perPage
        const page = action.payload.page
        const sortname = action.payload.sortname
        const sortorder = action.payload.sortorder

        const sortData = sortorder ? sorting(sortname, sortorder, state.allData) : state.allData
        state.data = paginateArray(sortData, perPage, page)
        state.totalCount = sortData.length
        state.perPage = perPage
        state.page = page
      })
      .addCase(GetDialyExchangeData.fulfilled, (state, action) => {
        if (action.payload?.data) {
          const quotes = action.payload.data
          state.devData = quotes ? quotes : null
          state.dSpinner = action.payload.spinner
        }
      })
      .addCase(GetInvoiceDocument.fulfilled, (state, action) => {

        if (action.payload?.data) {
          state.invoiceDocument = action.payload.data
        } else {
          state.invoiceDocument = {}
        }
      })

      .addCase(UpdateCurrecyLookupData.fulfilled, (state, action) => {
        if (action.payload?.data) {
          const wdata = action.payload?.data
          const allData = JSON.parse(JSON.stringify(state.allData))
          if (wdata?.id) {
            const findIndex = allData.findIndex(find => find.id === wdata?.id)
            if (findIndex >= 0) {
              allData[findIndex]['markUp'] = wdata?.data?.MarkUp ? Number(wdata?.data?.MarkUp) : 0
              allData[findIndex]['fxRate'] = wdata?.data?.FXRate ? Number(wdata?.data?.FXRate) : 0
            }
          }
          const perPage = state.perPage
          const page = state.page
          const arrayOfObjectsWithDates = allData
          state.allData = arrayOfObjectsWithDates
          state.data = paginateArray(arrayOfObjectsWithDates, perPage, page)
          state.totalCount = arrayOfObjectsWithDates.length
        }
      })

      // pending request tab
      .addCase(CFilterApprovalData.fulfilled, (state, action) => {
        if (action.payload) {
          const perPage = action.payload.perPage
          const page = action.payload.page
          const searchSymbol = action.payload.searchSymbol
          const requestedBy = action.payload.requestedBy
          const approvedBy = action.payload.approvedBy
          const fromDate = action.payload.fromCreatedDate
          const toDate = action.payload.toCreatedDate
          const rfromDate = action.payload.rfromCreatedDate
          const rtoDate = action.payload.rtoCreatedDate
          const arrayOfObjectsWithDates = action.payload.data
          const woDataObj = []
          for (let i = 0; i < arrayOfObjectsWithDates.length; i++) {
            const data = JSON.parse(arrayOfObjectsWithDates[i].data)
            const eleObj = {}
            eleObj['id'] = `${i + 1}`
            eleObj['aId'] = arrayOfObjectsWithDates[i].id
            eleObj['RefId'] = arrayOfObjectsWithDates[i].refId

            eleObj['OldMarkUp'] = data.OldMarkUp ? Number(data.OldMarkUp) : 0
            eleObj['OldMarkUpVal'] = `${data.OldMarkUp ? Number(data.OldMarkUp).toFixed(3) : Number(0).toFixed(3)} %`

            eleObj['MarkUp'] = data.MarkUp ? Number(data.MarkUp) : 0
            eleObj['MarkUpVal'] = `${data.MarkUp ? Number(data.MarkUp).toFixed(3) : Number(0).toFixed(3)} %`

            eleObj['OldFXRate'] = data.OldFXRate ? Number(data.OldFXRate) : 0
            eleObj['OldFXRateVal'] = `${data.OldFXRate ? Number(data.OldFXRate).toFixed(4) : Number(0).toFixed(4)} ${data.Symbol}/$`

            eleObj['FXRate'] = data.FXRate ? Number(data.FXRate) : 0
            eleObj['FXRateVal'] = `${data.FXRate ? Number(data.FXRate).toFixed(4) : Number(0).toFixed(4)} ${data.Symbol}/$`

            const OldFXRate = Number(data.OldFXRate) + (Number(data.OldFXRate) * (Number(data.OldMarkUp) / 100))
            eleObj['OldFixedRate'] = parseFloat(Number(OldFXRate).toFixed(4))
            eleObj['OldFixedRateVal'] = `${Number(OldFXRate).toFixed(4)} ${data.Symbol}/$`

            const FXRate = Number(data.FXRate) + (Number(data.FXRate) * (Number(data.MarkUp) / 100))
            eleObj['FixedRate'] = parseFloat(Number(FXRate).toFixed(4))
            eleObj['FixedRateVal'] = `${Number(FXRate).toFixed(4)} ${data.Symbol}/$`

            eleObj['Symbol'] = data.Symbol
            eleObj['name'] = data.Name
            eleObj['code'] = data.Code

            eleObj['cname'] = `${data.Code} - ${data.Name} (${data.Symbol})`
            eleObj['createdDate'] = DateTimeConversion(arrayOfObjectsWithDates[i].createdDate)
            eleObj['date'] = DateConversion(arrayOfObjectsWithDates[i].createdDate)

            eleObj['approvalDate'] = DateTimeConversion(arrayOfObjectsWithDates[i].approvalDate)

            eleObj['notes'] = arrayOfObjectsWithDates[i].notes ? arrayOfObjectsWithDates[i].notes : ''
            eleObj['fullName'] = `${arrayOfObjectsWithDates[i]?.firstName ? arrayOfObjectsWithDates[i]?.firstName : ''}`
            eleObj['approvalName'] = `${arrayOfObjectsWithDates[i]?.approvalName ? arrayOfObjectsWithDates[i]?.approvalName : ''}`
            woDataObj.push(eleObj)
          }
          state.hisData = woDataObj
          state.hallData = woDataObj

          if (searchSymbol) {
            state.hallData = state.hallData.filter(find => find.CurrencyId === searchSymbol)
          }

          if (requestedBy) {
            state.hallData = state.hallData.filter(find => ((find.fullName && String(find.fullName).toLowerCase().includes(requestedBy.toLowerCase()))))
          }

          if (approvedBy) {
            state.hallData = state.hallData.filter(find => ((find.approvalName && String(find.approvalName).toLowerCase().includes(approvedBy.toLowerCase()))))
          }

          if (fromDate && toDate) {
            const startDate = new Date(fromDate)
            const endDate = new Date(toDate)
            const filteredData = state.hallData.filter(item => {
              const itemDate = new Date(item.createdDate)
              return itemDate >= startDate && itemDate <= endDate
            })
            state.hallData = filteredData
          } else if (fromDate) {
            const startDate = new Date(fromDate)
            const filteredData = state.hallData.filter(item => {
              const itemDate = new Date(item.createdDate)
              return itemDate >= startDate
            })
            state.hallData = filteredData
          }

          if (rfromDate && rtoDate) {
            const startDate = new Date(rfromDate)
            const endDate = new Date(rtoDate)
            const filteredData = state.hallData.filter(item => {
              const itemDate = new Date(item.approvalDate)
              return itemDate >= startDate && itemDate <= endDate
            })
            state.hallData = filteredData
          } else if (rfromDate) {
            const startDate = new Date(rfromDate)
            const filteredData = state.hallData.filter(item => {
              const itemDate = new Date(item.approvalDate)
              return itemDate >= startDate
            })
            state.hallData = filteredData
          }

          state.hallData = state.hallData
          state.hdata = paginateArray(state.hallData, perPage, page)
          state.htotalCount = state.hallData.length
          state.hperPage = perPage
          state.hpage = page
          state.hSpinner = action.payload.spinner
        }
      })
      .addCase(CurrencyHistoryData.fulfilled, (state, action) => {
        if (action.payload) {
          const perPage = action.payload.perPage
          const page = action.payload.page
          const searchSymbol = action.payload.searchSymbol
          const requestedBy = action.payload.requestedBy
          const approvedBy = action.payload.approvedBy
          const fromDate = action.payload.fromCreatedDate
          const toDate = action.payload.toCreatedDate
          const arrayOfObjectsWithDates = action.payload.data
          const woDataObj = []
          for (let i = 0; i < arrayOfObjectsWithDates.length; i++) {
            const data = arrayOfObjectsWithDates[i]
            // const allCData = state.allCData
            // const findCurrency = allCData.find(find => find.value === data.currencyId)
            const eleObj = {}
            eleObj['id'] = `${i + 1}`
            eleObj['AgentId'] = data.agentId
            eleObj['CurrencyId'] = data.id
            eleObj['MarkUp'] = data.markUp ? Number(data.markUp) : 0
            eleObj['FXRate'] = data.fxRate ? Number(data.fxRate) : 0
            eleObj['MarkUpVal'] = `${data.markUp ? Number(data.markUp).toFixed(3) : Number(0).toFixed(3)} %`
            eleObj['FXRateVal'] = `${data.fxRate ? Number(data.fxRate).toFixed(4) : Number(0).toFixed(4)} ${data.symbol}/$`

            const FXRate = Number(data.fxRate) + (Number(data.fxRate) * (Number(data.markUp) / 100))

            eleObj['FixedRate'] = parseFloat(Number(FXRate).toFixed(4))
            eleObj['FixedRateVal'] = `${Number(FXRate).toFixed(4)} ${data.symbol}/$`

            eleObj['Symbol'] = data.symbol
            eleObj['name'] = data.name
            eleObj['code'] = data.code
            eleObj['cname'] = `${data.code} - ${eleObj.name} (${data.symbol})`
            eleObj['countryCode'] = data.countryCode
            eleObj['createdDate'] = DateTimeConversion(arrayOfObjectsWithDates[i].recordedDate)
            eleObj['date'] = DateConversion(arrayOfObjectsWithDates[i].recordedDate)
            eleObj['fullName'] = `${arrayOfObjectsWithDates[i]?.requestedByName ? arrayOfObjectsWithDates[i]?.requestedByName : ''}`
            eleObj['approvedByName'] = `${arrayOfObjectsWithDates[i]?.approvedByName ? arrayOfObjectsWithDates[i]?.approvedByName : ''}`
            eleObj['notes'] = data.notes ? data.notes : ''
            woDataObj.push(eleObj)
          }
          state.hisData = woDataObj
          state.hallData = woDataObj

          if (searchSymbol) {
            state.hallData = state.hallData.filter(find => find.CurrencyId === searchSymbol)
          }

          if (requestedBy) {
            state.hallData = state.hallData.filter(find => ((find.fullName && String(find.fullName).toLowerCase().includes(requestedBy.toLowerCase()))))
          }

          if (approvedBy) {
            state.hallData = state.hallData.filter(find => ((find.approvedByName && String(find.approvedByName).toLowerCase().includes(approvedBy.toLowerCase()))))
          }

          if (fromDate && toDate) {
            const startDate = new Date(fromDate)
            const endDate = new Date(toDate)
            const filteredData = state.hallData.filter(item => {
              const itemDate = new Date(item.createdDate)
              return itemDate >= startDate && itemDate <= endDate
            })
            state.hallData = filteredData
          } else if (fromDate) {
            const startDate = new Date(fromDate)
            const filteredData = state.hallData.filter(item => {
              const itemDate = new Date(item.createdDate)
              return itemDate >= startDate
            })
            state.hallData = filteredData
          }
          state.hallData = state.hallData
          state.hdata = paginateArray(state.hallData, perPage, page)
          state.htotalCount = state.hallData.length
          state.hperPage = perPage
          state.hpage = page
          state.hSpinner = action.payload.spinner
        }
      })
      .addCase(getCHistoryData.fulfilled, (state, action) => {
        const perPage = action.payload.perPage
        const page = action.payload.page
        const sortname = action.payload.sortname
        const sortorder = action.payload.sortorder
        const searchSymbol = action.payload.searchSymbol
        const requestedBy = action.payload.requestedBy
        const approvedBy = action.payload.approvedBy
        const fromDate = action.payload.fromCreatedDate
        const toDate = action.payload.toCreatedDate
        const rfromDate = action.payload.rfromCreatedDate
        const rtoDate = action.payload.rtoCreatedDate
        state.hallData = JSON.parse(JSON.stringify(state.hisData))
        if (searchSymbol) {
          state.hallData = state.hallData.filter(find => find.CurrencyId === searchSymbol)
        }
        if (requestedBy) {
          state.hallData = state.hallData.filter(find => ((find.fullName && String(find.fullName).toLowerCase().includes(requestedBy.toLowerCase()))))
        }
        if (approvedBy) {
          state.hallData = state.hallData.filter(find => ((find.approvedByName && String(find.approvedByName).toLowerCase().includes(approvedBy.toLowerCase())) || (find.approvalName && String(find.approvalName).toLowerCase().includes(approvedBy.toLowerCase()))))
        }
        if (fromDate && toDate) {
          const startDate = new Date(fromDate)
          const endDate = new Date(toDate)
          const filteredData = state.hallData.filter(item => {
            const itemDate = new Date(item.createdDate)
            return itemDate >= startDate && itemDate <= endDate
          })
          state.hallData = filteredData
        } else if (fromDate) {
          const startDate = new Date(fromDate)
          const filteredData = state.hallData.filter(item => {
            const itemDate = new Date(item.createdDate)
            return itemDate >= startDate
          })
          state.hallData = filteredData
        }
        if (rfromDate && rtoDate) {
          const startDate = new Date(rfromDate)
          const endDate = new Date(rtoDate)
          const filteredData = state.hallData.filter(item => {
            const itemDate = new Date(item.approvalDate)
            return itemDate >= startDate && itemDate <= endDate
          })
          state.hallData = filteredData
        } else if (rfromDate) {
          const startDate = new Date(rfromDate)
          const filteredData = state.hallData.filter(item => {
            const itemDate = new Date(item.approvalDate)
            return itemDate >= startDate
          })
          state.hallData = filteredData
        }
        state.hallData = state.hallData
        const sortData = sortorder ? sorting(sortname, sortorder, state.hallData) : state.hallData
        state.hdata = paginateArray(sortData, perPage, page)
        state.htotalCount = sortData.length
        state.hperPage = perPage
        state.hpage = page
      })
      // end currency menu

      // start company mapping
      .addCase(GetAllCompanyCurrencyList.fulfilled, (state, action) => {
        if (action.payload) {
          const perPage = action.payload.perPage
          const page = action.payload.page
          const count = action.payload.count
          const arrayOfObjectsWithDates = action.payload.data
          for (let i = 0; i < arrayOfObjectsWithDates.length; i++) {
            const data = arrayOfObjectsWithDates[i]
            const allCData = state.allCData
            const findCurrency = allCData.find(find => find.value === data.currencyId)
            data['startDate'] = DateConversion(data.startDate)
            data['currencyName'] = findCurrency
            data['currencyCode'] = `${data.currencyCode} - ${findCurrency ? findCurrency.name : ''} (${findCurrency ? findCurrency.symbol : ''})`
          }
          state.hisData = arrayOfObjectsWithDates
          state.hallData = arrayOfObjectsWithDates

          state.hallData = state.hallData
          state.hdata = paginateArray(state.hallData, perPage, page)
          state.hperPage = perPage
          state.hpage = page
          state.htotalCount = count
          state.hSpinner = action.payload.spinner
        }
      })
      .addCase(getCompanyData.fulfilled, (state, action) => {
        const perPage = action.payload.perPage
        const page = action.payload.page
        const sortname = action.payload.sortname
        const sortorder = action.payload.sortorder
        const searchSymbol = action.payload.searchSymbol
        const requestedBy = action.payload.requestedBy
        const approvedBy = action.payload.approvedBy
        const agentId = action.payload.agentId
        const fromDate = action.payload.fromCreatedDate
        const toDate = action.payload.toCreatedDate
        const rfromDate = action.payload.rfromCreatedDate
        const rtoDate = action.payload.rtoCreatedDate
        state.hallData = JSON.parse(JSON.stringify(state.hisData))
        if (searchSymbol) {
          state.hallData = state.hallData.filter(find => find.currencyId === searchSymbol)
        }
        if (requestedBy) {
          state.hallData = state.hallData.filter(find => ((find.requestedByName && String(find.requestedByName).toLowerCase().includes(requestedBy.toLowerCase()))))
        }
        if (approvedBy) {
          state.hallData = state.hallData.filter(find => ((find.approvalName && String(find.approvalName).toLowerCase().includes(approvedBy.toLowerCase()))))
        }
        if (agentId) {
          state.hallData = state.hallData.filter(find => ((find.agentId && String(find.agentId).toLowerCase().includes(agentId.toLowerCase())) || (find.agentName && String(find.agentName).toLowerCase().includes(agentId.toLowerCase()))))
        }
        if (fromDate && toDate) {
          const startDate = new Date(fromDate).setHours(0, 0, 0, 0)
          const endDate = new Date(toDate).setHours(0, 0, 0, 0)
          const filteredData = state.hallData.filter(item => {
            const itemDate = new Date(item.recordedDate)
            return itemDate >= startDate && itemDate <= endDate
          })
          state.hallData = filteredData
        } else if (fromDate) {
          const startDate = new Date(fromDate).setHours(0, 0, 0, 0)
          const filteredData = state.hallData.filter(item => {
            const itemDate = new Date(item.recordedDate)
            return itemDate >= startDate
          })
          state.hallData = filteredData
        }
        if (rfromDate && rtoDate) {
          const startDate = new Date(rfromDate)
          const endDate = new Date(rtoDate)
          const filteredData = state.hallData.filter(item => {
            const itemDate = new Date(item.approvalDate)
            return itemDate >= startDate && itemDate <= endDate
          })
          state.hallData = filteredData
        } else if (rfromDate) {
          const startDate = new Date(rfromDate)
          const filteredData = state.hallData.filter(item => {
            const itemDate = new Date(item.approvalDate)
            return itemDate >= startDate
          })
          state.hallData = filteredData
        }
        state.hallData = state.hallData
        const sortData = sortorder ? sorting(sortname, sortorder, state.hallData) : state.hallData
        state.hdata = paginateArray(sortData, perPage, page)
        state.htotalCount = sortData.length
        state.hperPage = perPage
        state.hpage = page
      })
      .addCase(CMFilterApprovalData.fulfilled, (state, action) => {
        if (action.payload) {
          const perPage = action.payload.perPage
          const page = action.payload.page
          const searchSymbol = action.payload.searchSymbol
          const requestedBy = action.payload.requestedBy
          const approvedBy = action.payload.approvedBy
          const agentId = action.payload.agentId
          const fromDate = action.payload.fromCreatedDate
          const toDate = action.payload.toCreatedDate
          const rfromDate = action.payload.rfromCreatedDate
          const rtoDate = action.payload.rtoCreatedDate
          const arrayOfObjectsWithDates = action.payload.data
          const woDataObj = []
          for (let i = 0; i < arrayOfObjectsWithDates.length; i++) {
            const data = JSON.parse(arrayOfObjectsWithDates[i].data)
            const eleObj = {}
            const allCData = state.allCData
            const oldfindCurrency = allCData.find(find => find.value === data.OldCurrencyId)
            const findCurrency = allCData.find(find => find.value === data.CurrencyId)
            eleObj['agentId'] = data.AgentId
            eleObj['agentName'] = data.AgentName
            eleObj['startDateValue'] = data.StartDate
            eleObj['fileId'] = data.FileId ? data.FileId : null
            eleObj['startDate'] = DateConversion(data.StartDate)

            eleObj['oldcurrencyId'] = data.OldCurrencyId
            eleObj['oldcurrencyName'] = oldfindCurrency
            eleObj['oldcurrencyCode'] = `${oldfindCurrency ? oldfindCurrency.code : ''} - ${oldfindCurrency ? oldfindCurrency.name : ''} (${oldfindCurrency ? oldfindCurrency.symbol : ''})`
            eleObj['currencyId'] = data.CurrencyId
            eleObj['currencyName'] = findCurrency
            eleObj['currencyCode'] = `${findCurrency ? findCurrency.code : ''} - ${findCurrency ? findCurrency.name : ''} (${findCurrency ? findCurrency.symbol : ''})`

            eleObj['notes'] = arrayOfObjectsWithDates[i].notes
            eleObj['id'] = arrayOfObjectsWithDates[i].id
            eleObj['RefId'] = arrayOfObjectsWithDates[i].refId
            eleObj['requestedByName'] = arrayOfObjectsWithDates[i].firstName ? arrayOfObjectsWithDates[i].firstName : ''
            eleObj['approvalName'] = arrayOfObjectsWithDates[i].approvalName ? arrayOfObjectsWithDates[i].approvalName : ''
            eleObj['approvalDate'] = DateTimeConversion(arrayOfObjectsWithDates[i].approvalDate)
            woDataObj.push(eleObj)
          }
          state.hisData = woDataObj
          state.hallData = woDataObj

          if (searchSymbol) {
            state.hallData = state.hallData.filter(find => find.currencyId === searchSymbol)
          }
          if (requestedBy) {
            state.hallData = state.hallData.filter(find => ((find.requestedByName && String(find.requestedByName).toLowerCase().includes(requestedBy.toLowerCase()))))
          }
          if (approvedBy) {
            state.hallData = state.hallData.filter(find => ((find.approvalName && String(find.approvalName).toLowerCase().includes(approvedBy.toLowerCase()))))
          }
          if (agentId) {
            state.hallData = state.hallData.filter(find => ((find.agentId && String(find.agentId).toLowerCase().includes(agentId.toLowerCase())) || (find.agentName && String(find.agentName).toLowerCase().includes(agentId.toLowerCase()))))
          }
          if (fromDate && toDate) {
            const startDate = new Date(fromDate).setHours(0, 0, 0, 0)
            const endDate = new Date(toDate).setHours(0, 0, 0, 0)
            const filteredData = state.hallData.filter(item => {
              const itemDate = new Date(item.startDate)
              return itemDate >= startDate && itemDate <= endDate
            })
            state.hallData = filteredData
          } else if (fromDate) {
            const startDate = new Date(fromDate).setHours(0, 0, 0, 0)
            const filteredData = state.hallData.filter(item => {
              const itemDate = new Date(item.startDate)
              return itemDate >= startDate
            })
            state.hallData = filteredData
          }
          if (rfromDate && rtoDate) {
            const startDate = new Date(rfromDate)
            const endDate = new Date(rtoDate)
            const filteredData = state.hallData.filter(item => {
              const itemDate = new Date(item.approvalDate)
              return itemDate >= startDate && itemDate <= endDate
            })
            state.hallData = filteredData
          } else if (rfromDate) {
            const startDate = new Date(rfromDate)
            const filteredData = state.hallData.filter(item => {
              const itemDate = new Date(item.approvalDate)
              return itemDate >= startDate
            })
            state.hallData = filteredData
          }
          state.hallData = state.hallData
          state.hdata = paginateArray(state.hallData, perPage, page)
          state.htotalCount = state.hallData.length
          state.hperPage = perPage
          state.hpage = page
          state.hSpinner = action.payload.spinner
        }
      })
      .addCase(CompanyHistoryData.fulfilled, (state, action) => {
        if (action.payload) {
          const perPage = action.payload.perPage
          const page = action.payload.page
          const count = action.payload.count
          const arrayOfObjectsWithDates = action.payload.data
          for (let i = 0; i < arrayOfObjectsWithDates.length; i++) {
            const data = arrayOfObjectsWithDates[i]
            const allCData = state.allCData
            const findCurrency = allCData.find(find => find.value === data.currencyId)
            data['id'] = arrayOfObjectsWithDates[i].id
            data['agentId'] = data.agentId
            data['agentName'] = data.agentName
            data['CurrencyId'] = data.currencyId
            data['currencyName'] = findCurrency
            data['currencyCode'] = `${findCurrency ? findCurrency.code : ''} - ${findCurrency ? findCurrency.name : ''} (${findCurrency ? findCurrency.symbol : ''})`
            data['notes'] = data.notes
            data['lastupdatedDate'] = DateTimeConversion(arrayOfObjectsWithDates[i].lastUpdatedDate)
            data['recordedDate'] = DateTimeConversion(arrayOfObjectsWithDates[i].recordedDate)
            data['modifiedDate'] = DateTimeConversion(arrayOfObjectsWithDates[i].lastUpdatedDate)
            data['requestedByName'] = `${arrayOfObjectsWithDates[i].requestedByName ? arrayOfObjectsWithDates[i].requestedByName : ''}`
            data['approvedByName'] = `${arrayOfObjectsWithDates[i].approvedByName ? arrayOfObjectsWithDates[i].approvedByName : ''}`
          }
          state.hisData = arrayOfObjectsWithDates
          state.hallData = arrayOfObjectsWithDates

          state.hallData = state.hallData
          state.hdata = paginateArray(state.hallData, perPage, page)
          state.htotalCount = count
          state.hperPage = perPage
          state.hpage = page
          state.hSpinner = action.payload.spinner
        }
      })
      .addCase(getComHistoryData.fulfilled, (state, action) => {
        const perPage = action.payload.perPage
        const page = action.payload.page
        const sortname = action.payload.sortname
        const sortorder = action.payload.sortorder
        const searchSymbol = action.payload.searchSymbol
        const requestedBy = action.payload.requestedBy
        const approvedBy = action.payload.approvedBy
        const agentId = action.payload.agentId
        const fromDate = action.payload.fromCreatedDate
        const toDate = action.payload.toCreatedDate
        const mfromDate = action.payload.fromModifiedDate
        const mtoDate = action.payload.toModifiedDate
        state.hallData = JSON.parse(JSON.stringify(state.hisData))
        if (searchSymbol) {
          state.hallData = state.hallData.filter(find => find.CurrencyId === searchSymbol)
        }
        if (requestedBy) {
          state.hallData = state.hallData.filter(find => ((find.requestedByName && String(find.requestedByName).toLowerCase().includes(requestedBy.toLowerCase()))))
        }

        if (approvedBy) {
          state.hallData = state.hallData.filter(find => ((find.approvedByName && String(find.approvedByName).toLowerCase().includes(approvedBy.toLowerCase()))))
        }
        if (agentId) {
          state.hallData = state.hallData.filter(find => ((find.agentId && String(find.agentId).toLowerCase().includes(agentId.toLowerCase())) || (find.agentName && String(find.agentName).toLowerCase().includes(agentId.toLowerCase()))))
        }
        if (fromDate && toDate) {
          const startDate = new Date(fromDate)
          const endDate = new Date(toDate)
          const filteredData = state.hallData.filter(item => {
            const itemDate = new Date(item.recordedDate)
            return itemDate >= startDate && itemDate <= endDate
          })
          state.hallData = filteredData
        } else if (fromDate) {
          const startDate = new Date(fromDate)
          const filteredData = state.hallData.filter(item => {
            const itemDate = new Date(item.recordedDate)
            return itemDate >= startDate
          })
          state.hallData = filteredData
        }

        if (mfromDate && mtoDate) {
          const startDate = new Date(mfromDate)
          const endDate = new Date(mtoDate)
          const filteredData = state.hallData.filter(item => {
            const itemDate = new Date(item.modifiedDate)
            return itemDate >= startDate && itemDate <= endDate
          })
          state.hallData = filteredData
        } else if (mfromDate) {
          const startDate = new Date(mfromDate)
          const filteredData = state.hallData.filter(item => {
            const itemDate = new Date(item.modifiedDate)
            return itemDate >= startDate
          })
          state.hallData = filteredData
        }

        state.hallData = state.hallData
        const sortData = sortorder ? sorting(sortname, sortorder, state.hallData) : state.hallData
        state.hdata = paginateArray(sortData, perPage, page)
        state.htotalCount = sortData.length
        state.hperPage = perPage
        state.hpage = page
      })
      // end company mapping

      // start price book
      .addCase(GetAllProductPrices.fulfilled, (state, action) => {
        if (action.payload) {
          const perPage = action.payload.perPage
          const page = action.payload.page
          const count = action.payload.count
          const arrayOfObjectsWithDates = action.payload.data
          const woDataObj = []
          for (let i = 0; i < arrayOfObjectsWithDates.length; i++) {
            const data = { ...arrayOfObjectsWithDates[i] }
            data['id'] = `${i + 1}`
            data['productCode'] = data['productCode'] ? data['productCode'].trim() : ''
            data['currencyName'] = `${data.currencyCode} - ${data.currencyName ? data.currencyName : ''} (${data.currencySymbol})`
            data['markUpVal'] = Number(data.markUp).toFixed(3)
            data['fxRateVal'] = Number(data.fxRate).toFixed(4)
            data['usdAmountVal'] = Number(data.usdAmount).toFixed(2)

            // const FXRate = Number(data.fxRate) + (Number(data.fxRate) * (Number(data.markUp) / 100))

            data['fixedRate'] = parseFloat(Number(data.conversionRate).toFixed(4))
            data['fixedRateVal'] = Number(data.conversionRate).toFixed(4)

            // data['totalAmount'] = parseFloat(Number(Number(FXRate) * Number(data.usdAmount)).toFixed(2))
            // data['totalAmountVal'] = Number(Number(FXRate) * Number(data.usdAmount)).toFixed(2)

            data['totalAmount'] = parseFloat(Number(data.totalAmount).toFixed(2))
            data['totalAmountVal'] = Number(data.totalAmount).toFixed(2)

            data['createdDate'] = DateTimeConversion(arrayOfObjectsWithDates[i].createdDate)
            data['date'] = DateConversion(arrayOfObjectsWithDates[i].createdDate)
            data['userEmail'] = arrayOfObjectsWithDates[i]?.userEmail
            if (arrayOfObjectsWithDates[i]?.requestedBy) {
              data['fullName'] = `${arrayOfObjectsWithDates[i]?.requestedBy}`
            } else {
              data['fullName'] = ''
            }
            data['activeStatus'] = data.isActive ? 'Active' : 'Inactive'
            woDataObj.push(data)
          }

          state.pballData = woDataObj
          state.pbhisData = woDataObj
          state.pbdata = paginateArray(state.pballData, perPage, page)
          state.pbtotalCount = count
          state.pbperPage = perPage
          state.pbpage = page
          state.pbSpinner = action.payload.spinner
        }
      })
      .addCase(getPriceData.fulfilled, (state, action) => {
        const perPage = action.payload.perPage
        const page = action.payload.page
        const sortname = action.payload.sortname
        const sortorder = action.payload.sortorder
        const fromDate = action.payload.fromCreatedDate
        const toDate = action.payload.toCreatedDate
        const productCode = action.payload.productCode
        const lockValue = action.payload.lockValue
        const requestedBy = action.payload.requestedBy
        const statusValue = action.payload.statusValue
        state.pballData = JSON.parse(JSON.stringify(state.pbhisData))
        if (fromDate && toDate) {
          const startDate = new Date(fromDate)
          const endDate = new Date(toDate)
          const filteredData = state.pballData.filter(item => {
            const itemDate = new Date(item.createdDate)
            return itemDate >= startDate && itemDate <= endDate
          })
          state.pballData = filteredData
        } else if (fromDate) {
          const startDate = new Date(fromDate)
          const filteredData = state.pballData.filter(item => {
            const itemDate = new Date(item.createdDate)
            return itemDate >= startDate
          })
          state.pballData = filteredData
        }
        if (productCode) {
          state.pballData = state.pballData.filter(find => ((find.productCode && String(find.productCode).toLowerCase().includes(productCode.toLowerCase()))))
        }
        if (requestedBy) {
          state.pballData = state.pballData.filter(find => ((find.fullName && String(find.fullName).toLowerCase().includes(requestedBy.toLowerCase()))))
        }
        const trueBool = true
        if (lockValue) {
          state.pballData = state.pballData.filter(find => find.isLocked === (lockValue === 'Locked' ? trueBool : false))
        }
        if (statusValue) {
          state.pballData = state.pballData.filter(find => find.activeStatus === statusValue)
        }
        state.pballData = state.pballData
        const sortData = sortorder ? sorting(sortname, sortorder, state.pballData) : state.pballData
        state.pbdata = paginateArray(sortData, perPage, page)
        state.pbtotalCount = sortData.length
        state.pbperPage = perPage
        state.pbpage = page
      })

      .addCase(PBFilterApprovalData.fulfilled, (state, action) => {
        if (action.payload) {
          const perPage = action.payload.perPage
          const page = action.payload.page
          const searchSymbol = action.payload.searchSymbol
          const productCode = action.payload.productCode
          const requestedBy = action.payload.requestedBy
          const approvedBy = action.payload.approvedBy
          const lockValue = action.payload.status
          const rfromDate = action.payload.rfromCreatedDate
          const rtoDate = action.payload.rtoCreatedDate
          const woDataObj = []
          const arrayOfObjectsWithDates = action.payload.data
          for (let i = 0; i < arrayOfObjectsWithDates.length; i++) {
            const data = JSON.parse(arrayOfObjectsWithDates[i].data)
            const eleObj = {}
            const allCData = state.allCData
            const findCurrency = allCData.find(find => find.value === data.CurrencyId)
            eleObj['id'] = `${i + 1}`
            eleObj['productCode'] = data['ProductCode'] ? data['ProductCode'] : ''
            eleObj['isLocked'] = data['IsLocked']
            eleObj['currencyId'] = data['CurrencyId']
            eleObj['currencySymbol'] = findCurrency ? findCurrency.symbol : ''
            eleObj['currencyName'] = `${findCurrency ? findCurrency.code : ''} - ${findCurrency ? findCurrency.name : ''} (${findCurrency ? findCurrency.symbol : ''})`
            eleObj['description'] = data.Description

            eleObj['usdAmount'] = Number(data.USDAmount)
            eleObj['usdAmountVal'] = Number(data.USDAmount).toFixed(2)

            eleObj['markUp'] = Number(data.MarkUp)
            eleObj['oldMarkUp'] = data.OldMarkUp ? Number(data.OldMarkUp) : 0
            eleObj['oldMarkUpVal'] = `${data.OldMarkUp ? Number(data.OldMarkUp).toFixed(3) : Number(0).toFixed(3)} %`

            eleObj['markUpVal'] = Number(data.MarkUp).toFixed(3)

            eleObj['fxRate'] = Number(data.FXRate)
            eleObj['fxRateVal'] = Number(data.FXRate).toFixed(4)

            const FXRate = Number(data.FXRate) + (Number(data.FXRate) * (Number(data.MarkUp) / 100))

            eleObj['fixedRate'] = parseFloat(Number(FXRate).toFixed(4))
            eleObj['fixedRateVal'] = Number(FXRate).toFixed(4)

            eleObj['totalAmount'] = parseFloat(Number(Number(FXRate) * Number(data.USDAmount)).toFixed(2))
            eleObj['totalAmountVal'] = Number(Number(FXRate) * Number(data.USDAmount)).toFixed(2)

            eleObj['createdDate'] = DateTimeConversion(arrayOfObjectsWithDates[i].createdDate)
            eleObj['date'] = DateConversion(arrayOfObjectsWithDates[i].createdDate)
            eleObj['approvalDate'] = DateTimeConversion(arrayOfObjectsWithDates[i].approvalDate)
            eleObj['userEmail'] = arrayOfObjectsWithDates[i]?.userEmail
            eleObj['approvalName'] = arrayOfObjectsWithDates[i]?.approvalName ? arrayOfObjectsWithDates[i]?.approvalName : ''
            eleObj['fullName'] = arrayOfObjectsWithDates[i]?.firstName ? arrayOfObjectsWithDates[i]?.firstName : ''
            eleObj['notes'] = arrayOfObjectsWithDates[i].notes
            eleObj['id'] = arrayOfObjectsWithDates[i].id
            eleObj['RefId'] = arrayOfObjectsWithDates[i].refId
            woDataObj.push(eleObj)
          }
          state.hisData = woDataObj
          state.hallData = woDataObj

          if (searchSymbol) {
            state.hallData = state.hallData.filter(find => find.currencyId === searchSymbol)
          }
          if (productCode) {
            state.hallData = state.hallData.filter(find => (((find.productCode && String(find.productCode).toLowerCase().includes(productCode.toLowerCase())) || (find.description && String(find.description).toLowerCase().includes(productCode.toLowerCase())))))
          }
          const trueBool = true
          if (lockValue) {
            state.hallData = state.hallData.filter(find => find.isLocked === (lockValue === 'Locked' ? trueBool : false))
          }
          if (requestedBy) {
            state.hallData = state.hallData.filter(find => ((find.fullName && String(find.fullName).toLowerCase().includes(requestedBy.toLowerCase()))))
          }
          if (approvedBy) {
            state.hallData = state.hallData.filter(find => ((find.approvalName && String(find.approvalName).toLowerCase().includes(approvedBy.toLowerCase()))))
          }
          if (rfromDate && rtoDate) {
            const startDate = new Date(rfromDate)
            const endDate = new Date(rtoDate)
            const filteredData = state.hallData.filter(item => {
              const itemDate = new Date(item.approvalDate)
              return itemDate >= startDate && itemDate <= endDate
            })
            state.hallData = filteredData
          } else if (rfromDate) {
            const startDate = new Date(rfromDate)
            const filteredData = state.hallData.filter(item => {
              const itemDate = new Date(item.approvalDate)
              return itemDate >= startDate
            })
            state.hallData = filteredData
          }
          state.hallData = state.hallData
          state.hdata = paginateArray(state.hallData, perPage, page)
          state.htotalCount = state.hallData.length
          state.hperPage = perPage
          state.hpage = page
          state.hSpinner = action.payload.spinner
        }
      })
      .addCase(getPriceBookPendingData.fulfilled, (state, action) => {
        const perPage = action.payload.perPage
        const page = action.payload.page
        const sortname = action.payload.sortname
        const sortorder = action.payload.sortorder
        const searchSymbol = action.payload.searchSymbol
        const productCode = action.payload.productCode
        const lockValue = action.payload.status
        const requestedBy = action.payload.requestedBy
        const approvedBy = action.payload.approvedBy
        const rfromDate = action.payload.rfromCreatedDate
        const rtoDate = action.payload.rtoCreatedDate
        state.hallData = JSON.parse(JSON.stringify(state.hisData))
        if (searchSymbol) {
          state.hallData = state.hallData.filter(find => find.currencyId === searchSymbol)
        }
        if (productCode) {
          state.hallData = state.hallData.filter(find => (((find.productCode && String(find.productCode).toLowerCase().includes(productCode.toLowerCase())) || (find.description && String(find.description).toLowerCase().includes(productCode.toLowerCase())))))
        }
        if (lockValue) {
          state.hallData = state.hallData.filter(find => find.isLocked === lockValue)
        }
        if (requestedBy) {
          state.hallData = state.hallData.filter(find => ((find.fullName && String(find.fullName).toLowerCase().includes(requestedBy.toLowerCase()))))
        }
        if (approvedBy) {
          state.hallData = state.hallData.filter(find => ((find.approvalName && String(find.approvalName).toLowerCase().includes(approvedBy.toLowerCase()))))
        }
        if (rfromDate && rtoDate) {
          const startDate = new Date(rfromDate)
          const endDate = new Date(rtoDate)
          const filteredData = state.hallData.filter(item => {
            const itemDate = new Date(item.approvalDate)
            return itemDate >= startDate && itemDate <= endDate
          })
          state.hallData = filteredData
        } else if (rfromDate) {
          const startDate = new Date(rfromDate)
          const filteredData = state.hallData.filter(item => {
            const itemDate = new Date(item.approvalDate)
            return itemDate >= startDate
          })
          state.hallData = filteredData
        }
        state.hallData = state.hallData
        const sortData = sortorder ? sorting(sortname, sortorder, state.hallData) : state.hallData
        state.hdata = paginateArray(sortData, perPage, page)
        state.htotalCount = sortData.length
        state.hperPage = perPage
        state.hpage = page
      })

      .addCase(GetAllProductHistoryData.fulfilled, (state, action) => {
        if (action.payload) {
          const perPage = action.payload.perPage
          const page = action.payload.page
          const count = action.payload.count
          const isDownload = action.payload.isDownload
          const arrayOfObjectsWithDates = action.payload.data
          const woDataObj = []
          for (let i = 0; i < arrayOfObjectsWithDates.length; i++) {
            const data = arrayOfObjectsWithDates[i]
            const eleObj = {}
            eleObj['id'] = `${i + 1}`
            eleObj['productCode'] = data['productCode'] ? data['productCode'].trim() : ''
            eleObj['productId'] = data.productId
            eleObj['isLocked'] = data.isLocked
            eleObj['description'] = data.description
            eleObj['currencyName'] = `${data.currencyCode} - ${data.currencyName ? data.currencyName : ''} (${data.currencySymbol})`
            eleObj['symbol'] = data.currencySymbol

            eleObj['usdAmountVal'] = Number(data.usdAmount).toFixed(2)
            eleObj['markUpVal'] = Number(data.markUp).toFixed(3)
            eleObj['fxRateVal'] = Number(data.fxRate).toFixed(4)

            eleObj['conversionRateVal'] = (Number(data.conversionRate).toFixed(4))
            eleObj['totalAmountVal'] = Number(data.totalAmount).toFixed(2)

            eleObj['createdDate'] = DateTimeConversion(data.createdDate)
            eleObj['date'] = DateConversion(data.createdDate)
            eleObj['modifiedDate'] = DateTimeConversion(data.modifiedDate)
            eleObj['requestedBy'] = data.requestedBy ? data.requestedBy : ''
            eleObj['approvedBy'] = data.approvedBy ? data.approvedBy : ''
            eleObj['isActive'] = data.isActive
            woDataObj.push(eleObj)
          }

          if (isDownload) {
            state.excelData = woDataObj
          } else {
            state.hisData = woDataObj
            state.hallData = woDataObj
            state.hdata = paginateArray(state.hallData, perPage, page)
            state.htotalCount = count
            state.hperPage = perPage
            state.hpage = page
            state.hSpinner = action.payload.spinner
          }
        }
      })
      .addCase(PriceHistoryData.fulfilled, (state, action) => {
        if (action.payload) {
          const perPage = action.payload.perPage
          const page = action.payload.page
          const searchSymbol = action.payload.searchSymbol
          const productCode = action.payload.productCode
          const lockValue = action.payload.lockValue
          const requestedBy = action.payload.requestedBy
          const fromDate = action.payload.fromCreatedDate
          const toDate = action.payload.toCreatedDate
          const arrayOfObjectsWithDates = action.payload.data
          const woDataObj = []
          for (let i = 0; i < arrayOfObjectsWithDates.length; i++) {
            const data = JSON.parse(arrayOfObjectsWithDates[i].data)
            const allCData = state.allCData
            const findCurrency = allCData.find(find => find.value === data.CurrencyId)
            const eleObj = {}
            eleObj['id'] = arrayOfObjectsWithDates[i].id
            eleObj['productCode'] = data['ProductCode'] ? data['ProductCode'].trim() : ''
            eleObj['isLocked'] = data.IsLocked
            eleObj['productId'] = data.ProductId
            eleObj['description'] = data.Description
            eleObj['CurrencyId'] = data.CurrencyId
            eleObj['currencyName'] = findCurrency
            eleObj['currencyCode'] = `${findCurrency ? findCurrency.code : ''} - ${findCurrency ? findCurrency.name : ''} (${findCurrency ? findCurrency.symbol : ''})`
            eleObj['symbol'] = findCurrency ? findCurrency.symbol : ''
            eleObj['usdAmount'] = data.USDAmount
            eleObj['markUp'] = data.MarkUp
            eleObj['fxRate'] = data.FXRate
            const FXRate = Number(data.FXRate) + (Number(data.FXRate) * (Number(data.MarkUp) / 100))
            eleObj['fixedRate'] = parseFloat(Number(FXRate).toFixed(4))
            eleObj['totalAmount'] = parseFloat(Number(Number(FXRate) * Number(data.USDAmount)).toFixed(4))
            eleObj['createdDate'] = DateTimeConversion(arrayOfObjectsWithDates[i].createdDate)
            eleObj['date'] = DateConversion(arrayOfObjectsWithDates[i].createdDate)
            eleObj['userEmail'] = arrayOfObjectsWithDates[i].userEmail
            eleObj['fullName'] = `${arrayOfObjectsWithDates[i].firstName} ${arrayOfObjectsWithDates[i].lastName}`
            woDataObj.push(eleObj)
          }
          state.hisData = woDataObj
          state.hallData = woDataObj

          if (searchSymbol) {
            state.hallData = state.hallData.filter(find => find.CurrencyId === searchSymbol)
          }
          if (productCode) {
            state.hallData = state.hallData.filter(find => ((find.productCode && String(find.productCode).toLowerCase().includes(productCode.toLowerCase()))))
          }
          if (requestedBy) {
            state.hallData = state.hallData.filter(find => ((find.fullName && String(find.fullName).toLowerCase().includes(requestedBy.toLowerCase()))))
          }
          if (lockValue) {
            const trueBool = true
            state.hallData = state.hallData.filter(find => find.isLocked === (lockValue === 'Locked' ? trueBool : false))
          }

          if (fromDate && toDate) {
            const startDate = new Date(fromDate)
            const endDate = new Date(toDate)
            const filteredData = state.hallData.filter(item => {
              const itemDate = new Date(item.createdDate)
              return itemDate >= startDate && itemDate <= endDate
            })
            state.hallData = filteredData
          } else if (fromDate) {
            const startDate = new Date(fromDate)
            const filteredData = state.hallData.filter(item => {
              const itemDate = new Date(item.createdDate)
              return itemDate >= startDate
            })
            state.hallData = filteredData
          }

          state.hallData = state.hallData
          state.hdata = paginateArray(state.hallData, perPage, page)
          state.htotalCount = state.hallData.length
          state.hperPage = perPage
          state.hpage = page
          state.hSpinner = action.payload.spinner
        }
      })
      .addCase(getPriceHistoryData.fulfilled, (state, action) => {
        const perPage = action.payload.perPage
        const page = action.payload.page
        const sortname = action.payload.sortname
        const sortorder = action.payload.sortorder
        const searchSymbol = action.payload.searchSymbol
        const productCode = action.payload.productCode
        const lockValue = action.payload.lockValue
        const requestedBy = action.payload.requestedBy
        const fromDate = action.payload.fromCreatedDate
        const toDate = action.payload.toCreatedDate
        state.hallData = JSON.parse(JSON.stringify(state.hisData))
        if (searchSymbol) {
          state.hallData = state.hallData.filter(find => find.CurrencyId === searchSymbol)
        }
        if (productCode) {
          state.hallData = state.hallData.filter(find => ((find.productCode && String(find.productCode).toLowerCase().includes(productCode.toLowerCase()))))
        }
        if (requestedBy) {
          state.hallData = state.hallData.filter(find => ((find.fullName && String(find.fullName).toLowerCase().includes(requestedBy.toLowerCase()))))
        }
        if (lockValue) {
          const trueBool = true
          state.hallData = state.hallData.filter(find => find.isLocked === (lockValue === 'Locked' ? trueBool : false))
        }
        if (fromDate && toDate) {
          const startDate = new Date(fromDate)
          const endDate = new Date(toDate)
          const filteredData = state.hallData.filter(item => {
            const itemDate = new Date(item.createdDate)
            return itemDate >= startDate && itemDate <= endDate
          })
          state.hallData = filteredData
        } else if (fromDate) {
          const startDate = new Date(fromDate)
          const filteredData = state.hallData.filter(item => {
            const itemDate = new Date(item.createdDate)
            return itemDate >= startDate
          })
          state.hallData = filteredData
        }
        state.hallData = state.hallData
        const sortData = sortorder ? sorting(sortname, sortorder, state.hallData) : state.hallData
        state.hdata = paginateArray(sortData, perPage, page)
        state.htotalCount = sortData.length
        state.hperPage = perPage
        state.hpage = page
      })
      // end price book

      // start product code
      .addCase(GetAllProductCodes.fulfilled, (state, action) => {

        if (action.payload?.data) {
          const perPage = action.payload.perPage
          const page = action.payload.page
          const productCode = action.payload.productCode
          const lockValue = action.payload.lockValue
          const wpPriceDiffValue = action.payload.priceDiffvalue
          const wpStatusDiffValue = action.payload.statusDiffvalue
          const variablevalue = action.payload.variablevalue
          const arrayOfObjectsWithDates = action.payload.data
          const wpLockValue = action.payload.wpLockValue
          const sortname = action.payload.sortname
          const sortorder = action.payload.sortorder
          const admDescription = action.payload.admDescription
          const departmentValue = action.payload.departmentValue
          for (let i = 0; i < arrayOfObjectsWithDates.length; i++) {
            const data = arrayOfObjectsWithDates[i]
            data['amountVal'] = Number(data.amount).toFixed(2)
            data['wpAmountVal'] = data.wpAmount ? Number(data.wpAmount).toFixed(2) : "-"
            data['defaultPriceVal'] = data?.defaultPrice ? Number(data?.defaultPrice).toFixed(2) : "-"
            data['defaultPrice'] = data?.defaultPrice ? data?.defaultPrice : 0
            data['id'] = `${i + 1}`
            data['status'] = data.status ? 'Active' : 'Inactive'
            data['wpStatus'] = data.wpStatus ? 'Active' : 'Inactive'
            data["admDescription"] = data.admDescription || ""
          }
          state.pallData = arrayOfObjectsWithDates
          state.phallData = arrayOfObjectsWithDates
          if (productCode) {
            state.phallData = state.phallData.filter(find => ((find.productCode && String(find.productCode).toLowerCase().includes(productCode.toLowerCase())) || (find.description && String(find.description).toLowerCase().includes(productCode.toLowerCase()))))
          }
          if (admDescription) {
            state.phallData = state.phallData.filter(find => ((find.admDescription && String(find.admDescription).toLowerCase().includes(admDescription.toLowerCase()))))
          }
          if (lockValue) {
            state.phallData = state.phallData.filter(find => find.status === lockValue)
          }
          if (wpLockValue) {
            state.phallData = state.phallData.filter(find => find.wpStatus === wpLockValue)
          }
          if (wpPriceDiffValue) {
            state.phallData = state.phallData.filter(find => find.wpAmount !== find.amount && find.wpAmount !== null && find.wpAmount)
          }
          if (wpStatusDiffValue) {
            state.phallData = state.phallData.filter(find => find.status !== find.wpStatus && find.wpStatus !== null)
          }
          if (variablevalue) {
            const trueBool = true
            state.phallData = state.phallData.filter(find => find.isVariable === ((variablevalue === "true" || variablevalue === true) ? trueBool : false))
          }
          if (departmentValue) {
            state.phallData = state.phallData.filter(find => find.wP_BusinessDivision === departmentValue)
          }
          state.phallData = state.phallData
          const sortData = sortorder ? sorting(sortname, sortorder, state.phallData) : state.phallData
          state.pdata = paginateArray(sortData, perPage, page)
          state.ptotalCount = state.phallData.length
          state.pperPage = perPage
          state.ppage = page
          state.pSpinner = action.payload.spinner
        }
      })
      .addCase(getProductData.fulfilled, (state, action) => {

        const perPage = action.payload.perPage
        const page = action.payload.page
        const sortname = action.payload.sortname
        const sortorder = action.payload.sortorder
        const productCode = action.payload.productCode
        const wpPriceDiffValue = action.payload.priceDiffvalue
        const wpStatusDiffValue = action.payload.statusDiffvalue
        const variablevalue = action.payload.variablevalue
        const lockValue = action.payload.lockValue
        const wpLockValue = action.payload.wpLockValue
        const admDescription = action.payload.admDescription
        const departmentValue = action.payload.departmentValue
        state.phallData = JSON.parse(JSON.stringify(state.pallData))

        if (productCode) {
          state.phallData = state.phallData.filter(find => ((find.productCode && String(find.productCode).toLowerCase().includes(productCode.toLowerCase())) || (find.description && String(find.description).toLowerCase().includes(productCode.toLowerCase()))))
        }
        if (admDescription) {
          state.phallData = state.phallData.filter((find) => {
            if ((find.admDescription && String(find.admDescription).toLowerCase().includes(admDescription.toLowerCase()))) {
              return find
            }
          })
        }
        if (lockValue) {
          state.phallData = state.phallData.filter(find => find.status === lockValue)
        }
        if (wpLockValue) {
          state.phallData = state.phallData.filter(find => find.wpStatus === wpLockValue)
        }
        if (wpPriceDiffValue) {
          state.phallData = state.phallData.filter(find => find.wpAmount !== find.amount && find.wpAmount !== null && find.wpAmount)
        }
        if (departmentValue) {
          state.phallData = state.phallData.filter(find => find.wP_BusinessDivision === departmentValue)
        }
        if (wpStatusDiffValue) {
          state.phallData = state.phallData.filter(find => find.status !== find.wpStatus && find.wpStatus !== null)
        }
        if (variablevalue) {
          const trueBool = true
          state.phallData = state.phallData.filter(find => find.isVariable === ((variablevalue === "true" || variablevalue === true) ? trueBool : false))
        }

        const sortData = sortorder ? sorting(sortname, sortorder, state.phallData) : state.phallData
        state.pdata = paginateArray(sortData, perPage, page)
        state.ptotalCount = sortData.length
        state.pperPage = perPage
        state.ppage = page
      })
      // end product code

      // start role management
      .addCase(GetUsers.fulfilled, (state, action) => {
        if (action.payload) {
          state.uspiner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.usersData = action.payload.data
        }
      })
      .addCase(GetUserRoles.fulfilled, (state, action) => {
        if (action.payload) {
          state.urspiner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.userRoleData = action.payload.data
        }
      })
      .addCase(CreateUser.fulfilled, (state, action) => {
        if (action.payload) {
          state.uspiner = false
        }
      })
      .addCase(SaveUserRoles.fulfilled, (state, action) => {
        if (action.payload) {
          state.urspiner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
        }
      })
      // end role management

      // start
      .addCase(GetAllDiscountsData.fulfilled, (state, action) => {
        state.discounts = action.payload.data || []
        state.recCount = action.payload.recCount
        state.gridSize = action.payload.pageSize || state.gridSize
        // const arrayOfObjectsWithDates = action.payload.data
        const pageSize = action.payload.pageSize

        const page = action.payload.page
        // state.hallData = discounts
        state.htotalCount = state.recCount
        state.hallData = state.discounts
        state.hdata = state.hallData
      })
      .addCase(GetAllVesselDiscounts.fulfilled, (state, action) => {
        state.discounts = action.payload.data || []
        state.recCount = action.payload.recCount
        state.gridSize = action.payload.pageSize || state.gridSize
        // const arrayOfObjectsWithDates = action.payload.data
        const pageSize = action.payload.pageSize

        const page = action.payload.page
        // state.hallData = discounts
        state.htotalCount = state.recCount
        state.hallData = state.discounts
        state.hdata = state.hallData
      })

      .addCase(DHFilterApprovalData.fulfilled, (state, action) => {
        state.HistoryDiscountData = action.payload.data?.discountsList || []
        state.recCount = action.payload.recCount
        state.gridSize = action.payload.pageSize || state.gridSize
        const page = action.payload.page
        state.htotalCount = state.recCount
        state.hallData = state.HistoryDiscountData
        state.hdata = state.hallData
      })

      .addCase(DHFilterApprovalDatas.fulfilled, (state, action) => {
        state.HistoryDiscountData = action.payload.data?.approvalsList || []
        state.recCount = action.payload.recCount
        state.gridSize = action.payload.pageSize || state.gridSize
        // const page = action.payload.page
        state.htotalCount = state.recCount
        state.hallData = state.HistoryDiscountData
        state.hdata = state.hallData
      })

      .addCase(VDHFilterApprovalDatas.fulfilled, (state, action) => {
        state.HistoryDiscountData = action.payload.data?.approvalsList || []
        state.recCount = action.payload.recCount
        state.gridSize = action.payload.pageSize || state.gridSize
        // const page = action.payload.page
        state.htotalCount = state.recCount
        state.hallData = state.HistoryDiscountData
        state.hdata = state.hallData
      })

      .addCase(GetAllExpiredDiscounts.fulfilled, (state, action) => {
        state.HistoryDiscountData = action.payload.data?.discountsList || []
        state.recCount = action.payload.recCount
        state.gridSize = action.payload.pageSize || state.gridSize
        const page = action.payload.page
        state.htotalCount = state.recCount
        state.hallData = state.HistoryDiscountData
        state.hdata = state.hallData
      })

      .addCase(GetAllExpiredVesselDiscounts.fulfilled, (state, action) => {
        state.HistoryDiscountData = action.payload.data || []
        state.recCount = action.payload.recCount
        state.gridSize = action.payload.pageSize || state.gridSize
        const page = action.payload.page
        state.htotalCount = state.recCount
        state.hallData = state.HistoryDiscountData
        state.hdata = state.hallData
      })

      // .addCase(CreateDiscount.fulfilled, (state, action) => {
      //   if (action.payload?.data) {
      //     // state.discounts.push(action.payload.data)
      //   }
      // })


      .addCase(DFilterApprovalData.fulfilled, (state, action) => {
        if (action.payload) {
          const perPage = action.payload.perPage
          const page = action.payload.page
          const requestedBy = action.payload.requestedBy
          const approvedBy = action.payload.approvedBy
          const agentId = action.payload.agentId
          const productCode = action.payload.productCode
          const arrayOfObjectsWithDates = action.payload.data
          const woDataObj = []
          for (let i = 0; i < arrayOfObjectsWithDates.length; i++) {

            const data = JSON.parse(arrayOfObjectsWithDates[i].data)

            const eleObj = {}
            eleObj['id'] = `${i + 1}`
            eleObj['aId'] = arrayOfObjectsWithDates[i].id
            eleObj['RefId'] = arrayOfObjectsWithDates[i].refId

            eleObj['agentName'] = `${data.AgentName}`
            eleObj['startDate'] = data.StartDate
            eleObj['endDate'] = data.EndDate

            eleObj['ProductDetailsJson'] = data?.ProductDetailsJson ? data?.ProductDetailsJson : []
            eleObj['ProductDescription'] = data.ProductDescription
            eleObj["productAmount"] = String(data.ProductAmount)
            eleObj['discountValue'] = data.DiscountValue
            eleObj['discountType'] = data.DiscountType
            eleObj['finalPrice'] = String(data.FinalPrice)
            eleObj['priority'] = String(data.Priority)

            eleObj['startCount'] = data.StartCount
            eleObj['endCount'] = data.EndCount

            eleObj['isActive'] = data.status
            eleObj['createdDate'] = arrayOfObjectsWithDates[i].createdDate
            eleObj['approvedDate'] = arrayOfObjectsWithDates[i].approvedDate
            eleObj['createdBy'] = arrayOfObjectsWithDates[i].firstName
            eleObj['notes'] = arrayOfObjectsWithDates[i].notes ? arrayOfObjectsWithDates[i].notes : ''
            eleObj['requestedBy'] = `${arrayOfObjectsWithDates[i]?.firstName ? arrayOfObjectsWithDates[i]?.firstName : ''}`
            eleObj['firstName'] = `${arrayOfObjectsWithDates[i]?.firstName ? arrayOfObjectsWithDates[i]?.firstName : ''}`
            eleObj['approvalName'] = `${arrayOfObjectsWithDates[i]?.approvalName ? arrayOfObjectsWithDates[i]?.approvalName : ''}`
            eleObj["fileId"] = data.FileId ? data.FileId : ""
            eleObj["agentId"] = data.DiscountAgentId ? data.DiscountAgentId : ""
            eleObj["productCode"] = data.ProductCode

            // eleObj['approvalName'] = `${arrayOfObjectsWithDates[i]?.approvalName ? arrayOfObjectsWithDates[i]?.approvalName : ''}`
            woDataObj.push(eleObj)
          }
          state.hisData = woDataObj
          state.hallData = woDataObj

          if (requestedBy) {
            state.hallData = state.hallData.filter(find => ((find.fullName && String(find.fullName).toLowerCase().includes(requestedBy.toLowerCase()))))
          }

          if (approvedBy) {
            state.hallData = state.hallData.filter(find => ((find.approvalName && String(find.approvalName).toLowerCase().includes(approvedBy.toLowerCase()))))
          }

          if (approvedBy) {
            state.hallData = state.hallData.filter(find => ((find.approvalName && String(find.approvalName).toLowerCase().includes(approvedBy.toLowerCase()))))
          }
          if (agentId) {
            state.hallData = state.hallData.filter(find => ((find.agentName && String(find.agentName).toLowerCase().includes(agentId.toLowerCase()))))
          }
          // if (productCode) {
          //   state.hallData = state.hallData.filter(find => ((find.ProductDescription && String(find.ProductDescription).toLowerCase().includes(productCode.toLowerCase()))))
          // }

          if (productCode) {
            const codeLower = productCode.toLowerCase()
            state.hallData = state.hallData.filter(find => {
              const details = find?.ProductDetailsJson || []
              if (find?.ProductDetailsJson) {
                return details.some(pd => (pd.ProductCode && pd.ProductCode.toLowerCase().includes(codeLower)) || (pd.ProductDescription && pd.ProductDescription.toLowerCase().includes(codeLower)))
              } else {
                return (((find.productCode && String(find.productCode).toLowerCase().includes(productCode.toLowerCase())) || (find.ProductDescription && String(find.ProductDescription).toLowerCase().includes(productCode.toLowerCase()))))
              }
            })
          }

          state.hallData = state.hallData
          state.hdata = paginateArray(state.hallData, perPage, page)
          state.htotalCount = state.hallData.length
          state.hperPage = perPage
          state.hpage = page
          state.hSpinner = action.payload.spinner
        }
      })

      .addCase(VDFilterApprovalData.fulfilled, (state, action) => {
        if (action.payload) {
          const perPage = action.payload.perPage
          const page = action.payload.page
          const requestedBy = action.payload.requestedBy
          const approvedBy = action.payload.approvedBy
          const agentId = action.payload.agentId
          const productCode = action.payload.productCode
          const arrayOfObjectsWithDates = action.payload.data
          const woDataObj = []
          for (let i = 0; i < arrayOfObjectsWithDates.length; i++) {

            const data = JSON.parse(arrayOfObjectsWithDates[i].data)

            const eleObj = {}
            eleObj['id'] = `${i + 1}`
            eleObj['aId'] = arrayOfObjectsWithDates[i].id
            eleObj['RefId'] = arrayOfObjectsWithDates[i].refId

            eleObj['vesselName'] = `${data.VesselName}`
            eleObj['officialNumber'] = `${data.OfficialNumber}`
            eleObj['imoNumber'] = `${data.ImoNumber}`
            eleObj['startDate'] = data.StartDate
            eleObj['endDate'] = data.EndDate

            eleObj['ProductDetailsJson'] = data?.ProductDetailsJson ? data?.ProductDetailsJson : []
            eleObj['ProductDescription'] = data.ProductDescription
            eleObj["productAmount"] = String(data.ProductAmount)
            eleObj['discountValue'] = data.DiscountValue
            eleObj['discountType'] = data.DiscountType
            eleObj['finalPrice'] = String(data.FinalPrice)
            eleObj['priority'] = String(data.Priority)

            eleObj['startCount'] = data.StartCount
            eleObj['endCount'] = data.EndCount

            eleObj['isActive'] = data.status
            eleObj['createdDate'] = arrayOfObjectsWithDates[i].createdDate
            eleObj['approvedDate'] = arrayOfObjectsWithDates[i].approvedDate
            eleObj['createdBy'] = arrayOfObjectsWithDates[i].firstName
            eleObj['notes'] = arrayOfObjectsWithDates[i].notes ? arrayOfObjectsWithDates[i].notes : ''
            eleObj['requestedBy'] = `${arrayOfObjectsWithDates[i]?.firstName ? arrayOfObjectsWithDates[i]?.firstName : ''}`
            eleObj['firstName'] = `${arrayOfObjectsWithDates[i]?.firstName ? arrayOfObjectsWithDates[i]?.firstName : ''}`
            eleObj['approvalName'] = `${arrayOfObjectsWithDates[i]?.approvalName ? arrayOfObjectsWithDates[i]?.approvalName : ''}`
            eleObj["fileId"] = data.FileId ? data.FileId : ""
            eleObj["vesselId"] = data.DiscountAgentId ? data.DiscountAgentId : ""
            eleObj["productCode"] = data.ProductCode

            // eleObj['approvalName'] = `${arrayOfObjectsWithDates[i]?.approvalName ? arrayOfObjectsWithDates[i]?.approvalName : ''}`
            woDataObj.push(eleObj)
          }
          state.hisData = woDataObj
          state.hallData = woDataObj

          if (requestedBy) {
            state.hallData = state.hallData.filter(find => ((find.fullName && String(find.fullName).toLowerCase().includes(requestedBy.toLowerCase()))))
          }

          if (approvedBy) {
            state.hallData = state.hallData.filter(find => ((find.approvalName && String(find.approvalName).toLowerCase().includes(approvedBy.toLowerCase()))))
          }

          if (approvedBy) {
            state.hallData = state.hallData.filter(find => ((find.approvalName && String(find.approvalName).toLowerCase().includes(approvedBy.toLowerCase()))))
          }
          if (agentId) {
            state.hallData = state.hallData.filter(find => ((find.agentName && String(find.agentName).toLowerCase().includes(agentId.toLowerCase()))))
          }
          // if (productCode) {
          //   state.hallData = state.hallData.filter(find => ((find.ProductDescription && String(find.ProductDescription).toLowerCase().includes(productCode.toLowerCase()))))
          // }

          if (productCode) {
            const codeLower = productCode.toLowerCase()
            state.hallData = state.hallData.filter(find => {
              const details = find?.ProductDetailsJson || []
              if (find?.ProductDetailsJson) {
                return details.some(pd => (pd.ProductCode && pd.ProductCode.toLowerCase().includes(codeLower)) || (pd.ProductDescription && pd.ProductDescription.toLowerCase().includes(codeLower)))
              } else {
                return (((find.productCode && String(find.productCode).toLowerCase().includes(productCode.toLowerCase())) || (find.ProductDescription && String(find.ProductDescription).toLowerCase().includes(productCode.toLowerCase()))))
              }
            })
          }

          state.hallData = state.hallData
          state.hdata = paginateArray(state.hallData, perPage, page)
          state.htotalCount = state.hallData.length
          state.hperPage = perPage
          state.hpage = page
          state.hSpinner = action.payload.spinner
        }
      })

      // .addCase(UpdateDiscountLookUpData.fulfilled, (state, action) => {
      //   if (action.payload?.data) {
      //     const wdata = action.payload?.data
      //     const allData = JSON.parse(JSON.stringify(state.allData))
      //     if (wdata?.id) {
      //       const findIndex = allData.findIndex(find => find.id === wdata?.id)
      //       if (findIndex >= 0) {
      //         allData[findIndex]['Discount'] = wdata?.data?.MarkUp ? wdata?.data?.MarkUp : 0
      //         allData[findIndex]['DiscountType'] = wdata?.data?.DiscountType ? wdata?.data?.DiscountType : 0
      //       }
      //     }
      //     const perPage = state.perPage
      //     const page = state.page
      //     const arrayOfObjectsWithDates = allData
      //     state.allData = arrayOfObjectsWithDates
      //     state.data = paginateArray(arrayOfObjectsWithDates, perPage, page)
      //     state.totalCount = arrayOfObjectsWithDates.length
      //   }
      // })

      .addCase(getDisHistoryData.fulfilled, (state, action) => {
        const perPage = action.payload.perPage
        const page = action.payload.page
        const sortname = action.payload.sortname
        const sortorder = action.payload.sortorder
        const agentId = action.payload.agentId
        const productCode = action.payload.productCode
        state.hallDisData = JSON.parse(JSON.stringify(state.hisData))

        if (agentId) {
          state.hallDisData = state.hallDisData.filter(find => ((find.agentId && String(find.agentId).toLowerCase().includes(agentId.toLowerCase())) || (find.agentName && String(find.agentName).toLowerCase().includes(agentId.toLowerCase()))))
        }
        
        // if (productCode) {
        //   state.hallDisData = state.hallDisData.filter(find => (((find.productCode && String(find.productCode).toLowerCase().includes(productCode.toLowerCase())) || (find.ProductDescription && String(find.ProductDescription).toLowerCase().includes(productCode.toLowerCase())))))
        // }

        if (productCode) {
          const codeLower = productCode.toLowerCase()
          state.hallDisData = state.hallDisData.filter(find => {
            const details = find?.ProductDetailsJson || []
            if (find?.ProductDetailsJson) {
              return details.some(pd => (pd.ProductCode && pd.ProductCode.toLowerCase().includes(codeLower)) || (pd.ProductDescription && pd.ProductDescription.toLowerCase().includes(codeLower)))
            } else {
              return (((find.productCode && String(find.productCode).toLowerCase().includes(productCode.toLowerCase())) || (find.ProductDescription && String(find.ProductDescription).toLowerCase().includes(productCode.toLowerCase()))))
            }
          })
        }

        state.hallDisData = state.hallDisData
        const sortData = sortorder ? sorting(sortname, sortorder, state.hallDisData) : state.hallDisData
        state.hdata = paginateArray(sortData, perPage, page)
        state.htotalCount = sortData.length
        state.hperPage = perPage
        state.hpage = page
      })
      
      .addCase(getVDisHistoryData.fulfilled, (state, action) => {
        const perPage = action.payload.perPage
        const page = action.payload.page
        const sortname = action.payload.sortname
        const sortorder = action.payload.sortorder
        const vesselId = action.payload.vesselId
        const productCode = action.payload.productCode
        state.hallDisData = JSON.parse(JSON.stringify(state.hisData))

        if (vesselId) {
          state.hallDisData = state.hallDisData.filter(find => ((find?.imoNumber && String(find?.imoNumber).toLowerCase().includes(vesselId.toLowerCase())) || (find?.officialNumber && String(find?.officialNumber).toLowerCase().includes(vesselId.toLowerCase())) || (find.vesselName && String(find.vesselName).toLowerCase().includes(vesselId.toLowerCase()))))
        }
        
        // if (productCode) {
        //   state.hallDisData = state.hallDisData.filter(find => (((find.productCode && String(find.productCode).toLowerCase().includes(productCode.toLowerCase())) || (find.ProductDescription && String(find.ProductDescription).toLowerCase().includes(productCode.toLowerCase())))))
        // }

        if (productCode) {
          const codeLower = productCode.toLowerCase()
          state.hallDisData = state.hallDisData.filter(find => {
            const details = find?.ProductDetailsJson || []
            if (find?.ProductDetailsJson) {
              return details.some(pd => (pd.ProductCode && pd.ProductCode.toLowerCase().includes(codeLower)) || (pd.ProductDescription && pd.ProductDescription.toLowerCase().includes(codeLower)))
            } else {
              return (((find.productCode && String(find.productCode).toLowerCase().includes(productCode.toLowerCase())) || (find.ProductDescription && String(find.ProductDescription).toLowerCase().includes(productCode.toLowerCase()))))
            }
          })
        }

        state.hallDisData = state.hallDisData
        const sortData = sortorder ? sorting(sortname, sortorder, state.hallDisData) : state.hallDisData
        state.hdata = paginateArray(sortData, perPage, page)
        state.htotalCount = sortData.length
        state.hperPage = perPage
        state.hpage = page
      })

  }

})
export const { handleAddtoCart } = commonreducerSlice.actions
export default commonreducerSlice.reducer
